<template>
  <div class="form form-invoice pb-4">
    <h5>{{ $t("message.contracts.document_epi") }}</h5>
    <validation
      v-if="document_id != 'new'"
      :action="go_to_error"
      section="epi"
      :contractId="$route.params.id"
      :item="document_id"
    />
    <br />
    <div
      class="alert mt-2 alert-success rounded d-flex"
      v-if="ap_main.IsSigned"
    >
      <span style="flex-basis: 50%">
        {{ $t("message.contracts.signed_message_" + ap_main.SignatureType) }}
        {{ ap_main.SignDate }}<br />
        {{ ap_main.SignatureName }}
      </span>
    </div>
    <b-tabs pills content-class="mt-3" small v-model="current_tab">
      <b-tab
        :title="$t('message.contracts.document_epi_tab_1_short')"
        :title-link-attributes="{
          title: $t('message.contracts.document_epi_tab_1'),
        }"
      >
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            $v.ap_main.ap_main_decl_num.$error ? 'has-danger' : '',
          ]"
        >
          <input
            type="text"
            class="form-control"
            v-model="ap_main.ap_main_decl_num"
            :placeholder="$t('message.contracts.ap_main_decl_num')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_main_decl_num"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_main_decl_num"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_main_decl_num") }}</label
          >
          <label
            v-if="form_error && !$v.ap_main.ap_main_decl_num.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            $v.ap_main.ap_main_reg_num.$error ? 'has-danger' : '',
          ]"
        >
          <input
            type="text"
            class="form-control"
            v-model="ap_main.ap_main_reg_num"
            :placeholder="$t('message.contracts.ap_main_reg_num')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_main_reg_num"
            :disabled="is_field_readonly"
          />
          <label for="ap_main_reg_num" class="form-label-group-label shorter">{{
            $t("message.contracts.ap_main_reg_num")
          }}</label>
          <label
            v-if="form_error && !$v.ap_main.ap_main_reg_num.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span
          :class="['bmd-form-group mb-2 d-block form-label-group required']"
        >
          <!-- <b-form-datepicker :locale="locale" v-model="ap_main.ap_main_decl_date" :placeholder="$t('message.contracts.ap_main_decl_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="ap_main_decl_date"></b-form-datepicker>
					<label  v-if="ap_main.ap_main_decl_date!=''"  for="ap_main_decl_date" class="form-label-group-label shorter topped">{{$t('message.contracts.ap_main_decl_date')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="ap_main.ap_main_decl_date = ' '"
            @blur="
              ap_main.ap_main_decl_date == ' '
                ? (ap_main.ap_main_decl_date = '')
                : (ap_main.ap_main_decl_date = ap_main.ap_main_decl_date)
            "
            inputClass="form-control"
            v-model="ap_main.ap_main_decl_date"
            :placeholder="$t('message.contracts.ap_main_decl_date')"
            :inputAttr="{ id: 'ap_main_decl_date' }"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_main_decl_date"
            class="form-label-group-label shorter"
            :class="
              ap_main.ap_main_decl_date != '' &&
              ap_main.ap_main_decl_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.ap_main_decl_date") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            fm1_memb_country_focus
              ? 'focused'
              : '' /*, $v.ap_main.ap_main_country_code.$error?'has-danger':''*/,
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="$t('message.contracts.ap_main_country_code')"
            v-model="ap_main.ap_main_country_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_main_country_code" :options="countries" label="display_text" :class="['form-control', typeof ap_main.ap_main_country_code !== 'undefined' && ap_main.ap_main_country_code.value!==''?'vs--selected':'']" @search=fetchCountries v-model="ap_main.ap_main_country_code" :placeholder="$t('message.contracts.ap_main_country_code')" @focus="fm1_memb_country_Focused" @blur="fm1_memb_countryBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_main_country_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_main_country_code')}}</label> -->
          <!-- <label v-if="form_error && !$v.ap_main.ap_main_country_code.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
        </span>
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <!-- <b-form-datepicker :locale="locale" v-model="ap_main.ap_main_reg_date" :placeholder="$t('message.contracts.ap_main_reg_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="ap_main_reg_date"></b-form-datepicker>
					<label  v-if="ap_main.ap_main_reg_date!=''"  for="ap_main_reg_date" class="form-label-group-label shorter topped">{{$t('message.contracts.ap_main_reg_date')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="ap_main.ap_main_reg_date = ' '"
            @blur="
              ap_main.ap_main_reg_date == ' '
                ? (ap_main.ap_main_reg_date = '')
                : (ap_main.ap_main_reg_date = ap_main.ap_main_reg_date)
            "
            inputClass="form-control"
            v-model="ap_main.ap_main_reg_date"
            :placeholder="$t('message.contracts.ap_main_reg_date')"
            :inputAttr="{ id: 'ap_main_reg_date' }"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_main_reg_date"
            class="form-label-group-label shorter"
            :class="
              ap_main.ap_main_reg_date != '' && ap_main.ap_main_reg_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.ap_main_reg_date") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group ' /*, $v.ap_main.ap_main_trans_kind_code.$error?'has-danger':'',  ap_main_trans_kind_code_focus?'focused':''*/,
          ]"
        >
          <input
            type="text"
            disabled
            class="form-control"
            v-model="ap_main.ap_main_trans_kind_code"
            :placeholder="$t('message.contracts.ap_main_trans_kind_code')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_main_trans_kind_code"
          />
          <!--<v-select id="ap_main_transit_direction_code" :options="usage_codes" label="display_text" :class="['form-control', typeof ap_main.ap_main_trans_kind_code !== 'undefined' && ap_main.ap_main_trans_kind_code.value!==''?'vs--selected':'']" v-model="ap_main.ap_main_trans_kind_code" :placeholder="$t('message.contracts.ap_main_trans_kind_code')" @focus="ap_main_trans_kind_code_Focused" @blur="ap_main_trans_kind_codeBlurred" @search="fetchTransKinds"></v-select>-->
          <!-- <label for="ap_main_trans_kind_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_main_trans_kind_code')}}</label> -->
          <!--<label v-if="form_error && !$v.ap_main.ap_main_trans_kind_code.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label>-->
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_main_transit_direction_code_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            :indata="ap_main_transit_direction_codes"
            :placeholder="
              $t('message.contracts.ap_main_transit_direction_code')
            "
            v-model="ap_main.ap_main_transit_direction_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_main_transit_direction_code" :options="ap_main_transit_direction_codes" label="display_text" :class="['form-control', typeof ap_main.ap_main_transit_direction_code !== 'undefined' && ap_main.ap_main_transit_direction_code.value!==''?'vs--selected':'']" v-model="ap_main.ap_main_transit_direction_code" :placeholder="$t('message.contracts.ap_main_transit_direction_code')" @focus="ap_main_transit_direction_code_Focused" @blur="ap_main_transit_direction_codeBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_main_transit_direction_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_main_transit_direction_code')}}</label> -->
        </span>
        <div class="togglebutton other mt-md-3 form-label-group">
          <label class="control-label-sm">
            <span>{{
              $t("message.contracts.ap_main_electronic_document_sign")
            }}</span
            ><br /><br />
            <input
              type="checkbox"
              v-model="ap_main.ap_main_electronic_document_sign"
              :disabled="is_field_readonly"
            />
            <span class="toggle"></span>
            <span class="choise_2">{{ $t("message.yes") }}</span>
            <span class="choise_1">{{ $t("message.no") }}</span>
          </label>
        </div>
        <div class="togglebutton other mt-md-3 form-label-group">
          <label class="control-label-sm">
            <span>{{ $t("message.contracts.ap_main_carnet") }}</span
            ><br /><br />
            <input
              type="checkbox"
              v-model="ap_main.ap_main_carnet"
              :disabled="is_field_readonly"
            />
            <span class="toggle"></span>
            <span class="choise_2">{{ $t("message.yes") }}</span>
            <span class="choise_1">{{ $t("message.no") }}</span>
          </label>
        </div>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_main_declaration_kinds_focus ? 'focused' : '',
          ]"
        >
          <!--<input type="text" class="form-control" v-model="ap_main.ap_main_declaration_kind" :placeholder="$t('message.contracts.ap_main_declaration_kind')" autocomplete="off" style="cursor: auto;" id="ap_main_declaration_kind">-->
          <v-select-popup
            type="declaration_kind"
            :placeholder="$t('message.contracts.ap_main_declaration_kind')"
            v-model="ap_main.ap_main_declaration_kind"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_main_transit_direction_code" :options="declaration_kinds" label="display_text" :class="['form-control', typeof ap_main.ap_main_declaration_kind !== 'undefined' && ap_main.ap_main_declaration_kind.value!==''?'vs--selected':'']" v-model="ap_main.ap_main_declaration_kind" :placeholder="$t('message.contracts.ap_main_declaration_kind')" @focus="ap_main_declaration_kind_Focused" @blur="ap_main_declaration_kindBlurred" @search="fetchDeclarationKinds" :disabled="is_field_readonly"></v-select>
					<label for="ap_main_declaration_kind" class="form-label-group-label shorter">{{$t('message.contracts.ap_main_declaration_kind')}}</label> -->
        </span>
        <div class="togglebutton other mt-md-3 form-label-group">
          <label class="control-label-sm">
            <span>{{ $t("message.contracts.ap_main_subsoil_sign") }}</span
            ><br /><br />
            <input
              type="checkbox"
              v-model="ap_main.ap_main_subsoil_sign"
              :disabled="is_field_readonly"
            />
            <span class="toggle"></span>
            <span class="choise_2">{{ $t("message.yes") }}</span>
            <span class="choise_1">{{ $t("message.no") }}</span>
          </label>
        </div>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_main.ap_main_seal_number"
            :placeholder="$t('message.contracts.ap_main_seal_number')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_main_seal_number"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_main_seal_number"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_main_seal_number") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            $v.ap_main.ap_main_seal_quantity.$error ? 'has-danger' : '',
          ]"
        >
          <input
            maxlength="8"
            type="number"
            class="form-control"
            v-model="ap_main.ap_main_seal_quantity"
            :placeholder="$t('message.contracts.ap_main_seal_quantity')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_main_seal_quantity"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_main_seal_quantity"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_main_seal_quantity") }}</label
          >
          <label
            v-if="form_error && !$v.ap_main.ap_main_seal_quantity.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_main.ap_main_language_cuesad"
            :placeholder="$t('message.contracts.ap_main_language_cuesad')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_main_language_cuesad"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_main_language_cuesad"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_main_language_cuesad") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            fm1_memb_country2_focus
              ? 'focused'
              : '' /*, $v.ap_main.ap_main_recipient_country_code.$error?'has-danger':''*/,
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="
              $t('message.contracts.ap_main_recipient_country_code')
            "
            v-model="ap_main.ap_main_recipient_country_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_main_recipient_country_code" :options="countries" label="display_text" :class="['form-control', typeof ap_main.ap_main_recipient_country_code !== 'undefined' && ap_main.ap_main_recipient_country_code.value!==''?'vs--selected':'']" @search=fetchCountries v-model="ap_main.ap_main_recipient_country_code" :placeholder="$t('message.contracts.ap_main_recipient_country_code')" @focus="fm1_memb_country2_Focused" @blur="fm1_memb_country2Blurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_main_recipient_country_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_main_recipient_country_code')}}</label> -->
          <!-- <label v-if="form_error && !$v.ap_main.ap_main_recipient_country_code.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
        </span>
        <!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group',  ap_main_movement_code_focus?'focused':'']">
					<input type="text" class="form-control" v-model="ap_main.ap_main_movement_code" :placeholder="$t('message.contracts.ap_main_movement_code')" autocomplete="off" style="cursor: auto;" id="ap_main_movement_code">
					<v-select id="ap_main_movement_code" :options="goods_transfer_features" label="display_text" :class="['form-control', typeof ap_main.ap_main_movement_code !== 'undefined' && ap_main.ap_main_movement_code.value!==''?'vs--selected':'']" @search=fetchMovementCodes v-model="ap_main.ap_main_movement_code" :placeholder="$t('message.contracts.ap_main_movement_code')" @focus="ap_main_movement_code_Focused" @blur="ap_main_movement_codeBlurred"></v-select>	
					<label for="ap_main_movement_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_main_movement_code')}}</label>
				</span> -->
        <!-- <code-value :label="$t('message.contracts.ap_main_movement_code')" :value_placeholder="$t('message.contracts.ap_main_movement_code')" :code_placeholder="$t('message.contracts.ap_main_movement_code_code')" type="goods_transfer_feature" v-model="ap_main.ap_main_movement_code" :readonly="is_field_readonly"></code-value> -->

        <v-select-popup
          type="goods_transfer_feature"
          :placeholder="$t('message.contracts.ap_main_movement_code')"
          v-model="ap_main.ap_main_movement_code"
          :disabled="is_field_readonly"
        />
      </b-tab>
      <b-tab
        :title="$t('message.contracts.document_epi_tab_2_short')"
        :title-link-attributes="{
          title: $t('message.contracts.document_epi_tab_2'),
        }"
      >
        <h5>{{ $t("message.contracts.ap_goods_group") }}</h5>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_good_origin_country_name_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="$t('message.contracts.ap_good_origin_country_name')"
            v-model="ap_goods.ap_good_origin_country_name"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_good_origin_country_name" :options="countries" label="display_text" :class="['form-control', typeof ap_goods.ap_good_origin_country_name !== 'undefined' && ap_goods.ap_good_origin_country_name.value!==''?'vs--selected':'']" @search=fetchCountries v-model="ap_goods.ap_good_origin_country_name" :placeholder="$t('message.contracts.ap_good_origin_country_name')" @focus="ap_good_origin_country_name_Focused" @blur="ap_good_origin_country_nameBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_good_origin_country_name" class="form-label-group-label shorter">{{$t('message.contracts.ap_good_origin_country_name')}}</label> -->
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="number"
            class="form-control"
            v-model="ap_goods.ap_good_specification_number"
            :placeholder="$t('message.contracts.ap_good_specification_number')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_good_specification_number"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_good_specification_number"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_good_specification_number") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="number"
            class="form-control"
            v-model="ap_goods.ap_good_specification_list_number"
            :placeholder="
              $t('message.contracts.ap_good_specification_list_number')
            "
            autocomplete="off"
            style="cursor: auto"
            id="ap_good_specification_list_number"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_good_specification_list_number"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.ap_good_specification_list_number")
            }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            $v.ap_goods.ap_good_total_goods_number.$error ? 'has-danger' : '',
          ]"
        >
          <input
            type="number"
            class="form-control"
            v-model="ap_goods.ap_good_total_goods_number"
            :placeholder="$t('message.contracts.ap_good_total_goods_number')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_good_total_goods_number"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_good_total_goods_number"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_good_total_goods_number") }}</label
          >
          <label
            v-if="
              form_error && !$v.ap_goods.ap_good_total_goods_number.required
            "
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span
          :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
          id="ap_good_total_package_number"
        >
          <input
            type="number"
            class="form-control"
            v-model="ap_goods.ap_good_total_package_number"
            :placeholder="$t('message.contracts.ap_good_total_package_number')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_goods.ap_good_total_package_number"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_goods.ap_good_total_package_number"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_good_total_package_number") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="number"
            class="form-control"
            v-model="ap_goods.ap_good_total_sheet_number"
            :placeholder="$t('message.contracts.ap_good_total_sheet_number')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_goods.ap_good_total_sheet_number"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_goods.ap_good_total_sheet_number"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_good_total_sheet_number") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <cleave
            v-model="ap_goods.ap_good_total_cust_cost"
            :options="cleavePrice"
            class="form-control"
            :placeholder="$t('message.contracts.ap_good_total_cust_cost')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_good_total_cust_cost"
            :disabled="is_field_readonly"
          ></cleave>
          <label
            for="ap_good_total_cust_cost"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_good_total_cust_cost") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            fm1_oper_currency_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="currency"
            :placeholder="
              $t('message.contracts.ap_good_cust_cost_currency_code')
            "
            v-model="ap_goods.ap_good_cust_cost_currency_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_good_cust_cost_currency_code" :options="currencies" label="display_text" :class="['form-control', typeof ap_goods.ap_good_cust_cost_currency_code !== 'undefined' && ap_goods.ap_good_cust_cost_currency_code.value!==''?'vs--selected':'']" @search=fetchCurrency v-model="ap_goods.ap_good_cust_cost_currency_code" :placeholder="$t('message.contracts.ap_good_cust_cost_currency_code')" @focus="fm1_oper_currency_Focused" @blur="fm1_oper_currencyBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_good_cust_cost_currency_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_good_cust_cost_currency_code')}}</label> -->
        </span>
      </b-tab>
      <b-tab
        :title="$t('message.contracts.document_epi_tab_3_short')"
        :title-link-attributes="{
          title: $t('message.contracts.document_epi_tab_3'),
        }"
      >
        <h4>{{ $t("message.contracts.ap_sender_group") }}</h4>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members1.ap_memb_organization_name"
            :placeholder="$t('message.contracts.ap_memb_organization_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_organization_name"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_organization_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_organization_name") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members1.ap_memb_short_name"
            :placeholder="$t('message.contracts.ap_memb_short_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_short_name"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_short_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_short_name") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members1.ap_memb_bin"
                :placeholder="$t('message.contracts.ap_memb_bin')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_bin"
                :disabled="is_field_readonly"
              />
              <label for="ap_memb_bin" class="form-label-group-label shorter">{{
                $t("message.contracts.ap_memb_bin")
              }}</label>
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members1.ap_memb_itn"
                :placeholder="$t('message.contracts.ap_memb_itn')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_itn"
                :disabled="is_field_readonly"
              />
              <label for="ap_memb_itn" class="form-label-group-label shorter">{{
                $t("message.contracts.ap_memb_itn")
              }}</label>
            </span>
          </div>
        </div>

        <h5>{{ $t("message.contracts.ap_sender_org_address") }}</h5>
        <div class="row">
          <div class="col-md-5">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members1.ap_member_postal_code"
                :placeholder="$t('message.contracts.ap_member_postal_code')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_postal_code"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_postal_code"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_postal_code") }}</label
              >
            </span>
          </div>
          <div class="col-md-7">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                country1_focus ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="country"
                :placeholder="$t('message.contracts.ap_member_country_name')"
                v-model="ap_members1.ap_member_country_name"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="ap_member_country_name" :options="countries" label="display_text" :class="['form-control', typeof ap_members1.ap_member_country_name !== 'undefined' && ap_members1.ap_member_country_name.value!==''?'vs--selected':'']" @search=fetchCountries v-model="ap_members1.ap_member_country_name" :placeholder="$t('message.contracts.ap_member_country_name')" @focus="country1_Focused" @blur="country1Blurred" :disabled="is_field_readonly"></v-select>	
		               		<label for="ap_member_country_name" class="form-label-group-label shorter">{{$t('message.contracts.ap_member_country_name')}}</label> -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members1.ap_member_region"
                :placeholder="$t('message.contracts.ap_member_region')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_region"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_region"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_region") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members1.ap_member_city"
                :placeholder="$t('message.contracts.ap_member_city')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_city"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_city"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_city") }}</label
              >
            </span>
          </div>
        </div>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members1.ap_member_street_house"
            :placeholder="$t('message.contracts.ap_member_street_house')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_member_street_house"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_member_street_house"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_member_street_house") }}</label
          >
        </span>

        <h4>{{ $t("message.contracts.ap_recipient_group") }}</h4>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members2.ap_memb_organization_name"
            :placeholder="$t('message.contracts.ap_memb_organization_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_organization_name2"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_organization_name2"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_organization_name") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members2.ap_memb_short_name"
            :placeholder="$t('message.contracts.ap_memb_short_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_short_name2"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_short_name2"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_short_name") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members2.ap_memb_bin"
                :placeholder="$t('message.contracts.ap_memb_bin')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_bin2"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_memb_bin2"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_memb_bin") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members2.ap_memb_itn"
                :placeholder="$t('message.contracts.ap_memb_itn')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_itn2"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_memb_itn2"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_memb_itn") }}</label
              >
            </span>
          </div>
        </div>
        <h5>{{ $t("message.contracts.ap_recipient_address") }}</h5>
        <div class="row">
          <div class="col-md-5">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members2.ap_member_postal_code"
                :placeholder="$t('message.contracts.ap_member_postal_code')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_postal_code2"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_postal_code2"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_postal_code") }}</label
              >
            </span>
          </div>
          <div class="col-md-7">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                country2_focus ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="country"
                :placeholder="$t('message.contracts.ap_member_country_name')"
                v-model="ap_members2.ap_member_country_name"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="ap_member_country_name2" :options="countries" label="display_text" :class="['form-control', typeof ap_members2.ap_member_country_name !== 'undefined' && ap_members2.ap_member_country_name.value!==''?'vs--selected':'']" @search=fetchCountries v-model="ap_members2.ap_member_country_name" :placeholder="$t('message.contracts.ap_member_country_name')" @focus="country2_Focused" @blur="country2Blurred" :disabled="is_field_readonly"></v-select>	
		               		<label for="ap_member_country_name2" class="form-label-group-label shorter">{{$t('message.contracts.ap_member_country_name')}}</label> -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members2.ap_member_region"
                :placeholder="$t('message.contracts.ap_member_region')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_region2"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_region2"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_region") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members2.ap_member_city"
                :placeholder="$t('message.contracts.ap_member_city')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_city2"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_city2"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_city") }}</label
              >
            </span>
          </div>
        </div>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members2.ap_member_street_house"
            :placeholder="$t('message.contracts.ap_member_street_house')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_member_street_house2"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_member_street_house2"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_member_street_house") }}</label
          >
        </span>

        <h4>{{ $t("message.contracts.ap_lico_fin_ureg_group") }}</h4>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members3.ap_memb_organization_name"
            :placeholder="$t('message.contracts.ap_memb_organization_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_organization_name3"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_organization_name3"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_organization_name") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members3.ap_memb_short_name"
            :placeholder="$t('message.contracts.ap_memb_short_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_short_name3"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_short_name3"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_short_name") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members3.ap_memb_bin"
                :placeholder="$t('message.contracts.ap_memb_bin')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_bin3"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_memb_bin3"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_memb_bin") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members3.ap_memb_itn"
                :placeholder="$t('message.contracts.ap_memb_itn')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_itn3"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_memb_itn3"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_memb_itn") }}</label
              >
            </span>
          </div>
        </div>
        <h5>{{ $t("message.contracts.ap_lico_fin_ureg_address") }}</h5>
        <div class="row">
          <div class="col-md-5">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members3.ap_member_postal_code"
                :placeholder="$t('message.contracts.ap_member_postal_code')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_postal_code3"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_postal_code3"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_postal_code") }}</label
              >
            </span>
          </div>
          <div class="col-md-7">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                country3_focus ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="country"
                :placeholder="$t('message.contracts.ap_member_country_name')"
                v-model="ap_members3.ap_member_country_name"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="ap_member_country_name3" :options="countries" label="display_text" :class="['form-control', typeof ap_members3.ap_member_country_name !== 'undefined' && ap_members3.ap_member_country_name.value!==''?'vs--selected':'']" @search=fetchCountries v-model="ap_members3.ap_member_country_name" :placeholder="$t('message.contracts.ap_member_country_name')" @focus="country3_Focused" @blur="country3Blurred" :disabled="is_field_readonly"></v-select>	
		               		<label for="ap_member_country_name3" class="form-label-group-label shorter">{{$t('message.contracts.ap_member_country_name')}}</label> -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members3.ap_member_region"
                :placeholder="$t('message.contracts.ap_member_region')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_region3"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_region3"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_region") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members3.ap_member_city"
                :placeholder="$t('message.contracts.ap_member_city')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_city3"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_city3"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_city") }}</label
              >
            </span>
          </div>
        </div>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members3.ap_member_street_house"
            :placeholder="$t('message.contracts.ap_member_street_house')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_member_street_house3"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_member_street_house3"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_member_street_house") }}</label
          >
        </span>

        <h4>{{ $t("message.contracts.ap_declarant_group") }}</h4>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members4.ap_memb_organization_name"
            :placeholder="$t('message.contracts.ap_memb_organization_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_organization_name4"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_organization_name4"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_organization_name") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members4.ap_memb_short_name"
            :placeholder="$t('message.contracts.ap_memb_short_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_short_name4"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_short_name4"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_short_name") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members4.ap_memb_bin"
                :placeholder="$t('message.contracts.ap_memb_bin')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_bin4"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_memb_bin4"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_memb_bin") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members4.ap_memb_itn"
                :placeholder="$t('message.contracts.ap_memb_itn')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_itn4"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_memb_itn4"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_memb_itn") }}</label
              >
            </span>
          </div>
        </div>
        <h5>{{ $t("message.contracts.ap_declarant_address") }}</h5>
        <div class="row">
          <div class="col-md-5">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members4.ap_member_postal_code"
                :placeholder="$t('message.contracts.ap_member_postal_code')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_postal_code4"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_postal_code4"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_postal_code") }}</label
              >
            </span>
          </div>
          <div class="col-md-7">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                country4_focus ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="country"
                :placeholder="$t('message.contracts.ap_member_country_name')"
                v-model="ap_members4.ap_member_country_name"
                :disabled="is_field_readonly"
              />
              <!-- <v-select id="ap_member_country_name4" :options="countries" label="display_text" :class="['form-control', typeof ap_members4.ap_member_country_name !== 'undefined' && ap_members4.ap_member_country_name.value!==''?'vs--selected':'']" @search=fetchCountries v-model="ap_members4.ap_member_country_name" :placeholder="$t('message.contracts.ap_member_country_name')" @focus="country4_Focused" @blur="country4Blurred" :disabled="is_field_readonly"></v-select>	
		               		<label for="ap_member_country_name4" class="form-label-group-label shorter">{{$t('message.contracts.ap_member_country_name')}}</label> -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members4.ap_member_region"
                :placeholder="$t('message.contracts.ap_member_region')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_region4"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_region4"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_region") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members4.ap_member_city"
                :placeholder="$t('message.contracts.ap_member_city')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_city4"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_city4"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_city") }}</label
              >
            </span>
          </div>
        </div>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members4.ap_member_street_house"
            :placeholder="$t('message.contracts.ap_member_street_house')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_member_street_house4"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_member_street_house4"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_member_street_house") }}</label
          >
        </span>

        <h4>{{ $t("message.contracts.ap_person_declaraed_group") }}</h4>
        <div class="row">
          <div class="col-md-4">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group required',
                $v.ap_persons.ap_person_person_surname.$error
                  ? 'has-danger'
                  : '',
              ]"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_persons.ap_person_person_surname"
                :placeholder="$t('message.contracts.ap_person_person_surname')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_person_person_surname"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_person_person_surname"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_person_person_surname") }}</label
              >
              <label
                v-if="
                  form_error && !$v.ap_persons.ap_person_person_surname.required
                "
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group required',
                $v.ap_persons.ap_person_person_name.$error ? 'has-danger' : '',
              ]"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_persons.ap_person_person_name"
                :placeholder="$t('message.contracts.ap_person_person_name')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_person_person_name"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_person_person_name"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_person_person_name") }}</label
              >
              <label
                v-if="
                  form_error && !$v.ap_persons.ap_person_person_name.required
                "
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_persons.ap_person_person_middle_name"
                :placeholder="
                  $t('message.contracts.ap_person_person_middle_name')
                "
                autocomplete="off"
                style="cursor: auto"
                id="ap_person_person_middle_name"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_person_person_middle_name"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.ap_person_person_middle_name")
                }}</label
              >
            </span>
          </div>
        </div>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_persons.ap_person_person_post"
            :placeholder="$t('message.contracts.ap_person_person_post')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_person_person_post"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_person_person_post"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_person_person_post") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_persons.ap_person_contact_phone"
            :placeholder="$t('message.contracts.ap_person_contact_phone')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_person_contact_phone"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_person_contact_phone"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_person_contact_phone") }}</label
          >
        </span>

        <h4>{{ $t("message.contracts.ap_courier_group") }}</h4>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members5.ap_memb_organization_name"
            :placeholder="$t('message.contracts.ap_memb_organization_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_organization_name5"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_organization_name5"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_organization_name") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members5.ap_memb_short_name"
            :placeholder="$t('message.contracts.ap_memb_short_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_memb_short_name5"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_memb_short_name5"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_memb_short_name") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members5.ap_memb_bin"
                :placeholder="$t('message.contracts.ap_memb_bin')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_bin5"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_memb_bin5"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_memb_bin") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members5.ap_memb_itn"
                :placeholder="$t('message.contracts.ap_memb_itn')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_memb_itn5"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_memb_itn5"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_memb_itn") }}</label
              >
            </span>
          </div>
        </div>
        <h5>{{ $t("message.contracts.ap_declarant_address") }}</h5>
        <div class="row">
          <div class="col-md-5">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members5.ap_member_postal_code"
                :placeholder="$t('message.contracts.ap_member_postal_code')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_postal_code5"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_postal_code5"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_postal_code") }}</label
              >
            </span>
          </div>
          <div class="col-md-7">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                country5_focus ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="country"
                :placeholder="$t('message.contracts.ap_member_country_name')"
                v-model="ap_members5.ap_member_country_name"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="ap_member_country_name5" :options="countries" label="display_text" :class="['form-control', typeof ap_members5.ap_member_country_name !== 'undefined' && ap_members5.ap_member_country_name.value!==''?'vs--selected':'']" @search=fetchCountries v-model="ap_members5.ap_member_country_name" :placeholder="$t('message.contracts.ap_member_country_name')" @focus="country5_Focused" @blur="country5Blurred" :disabled="is_field_readonly"></v-select>	
		               		<label for="ap_member_country_name5" class="form-label-group-label shorter">{{$t('message.contracts.ap_member_country_name')}}</label> -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members5.ap_member_region"
                :placeholder="$t('message.contracts.ap_member_region')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_region5"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_region5"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_region") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_members5.ap_member_city"
                :placeholder="$t('message.contracts.ap_member_city')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_member_city5"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_member_city5"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_member_city") }}</label
              >
            </span>
          </div>
        </div>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_members5.ap_member_street_house"
            :placeholder="$t('message.contracts.ap_member_street_house')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_member_street_house5"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_member_street_house5"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_member_street_house") }}</label
          >
        </span>
        <h4>{{ $t("message.contracts.ap_drivers_group") }}</h4>
        <div class="row">
          <div class="col-md-4">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_persons2.ap_person_person_surname"
                :placeholder="$t('message.contracts.ap_person_person_surname')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_person_person_surname2"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_person_person_surname2"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_person_person_surname") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_persons2.ap_person_person_name"
                :placeholder="$t('message.contracts.ap_person_person_name')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_person_person_name2"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_person_person_name2"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_person_person_name") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_persons2.ap_person_person_middle_name"
                :placeholder="
                  $t('message.contracts.ap_person_person_middle_name')
                "
                autocomplete="off"
                style="cursor: auto"
                id="ap_person_person_middle_name2"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_person_person_middle_name2"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.ap_person_person_middle_name")
                }}</label
              >
            </span>
          </div>
        </div>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_persons2.ap_person_person_post"
            :placeholder="$t('message.contracts.ap_person_person_post')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_person_person_post2"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_person_person_post2"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_person_person_post") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            country6_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="$t('message.contracts.ap_person_reg_country_code')"
            v-model="ap_persons2.ap_person_reg_country_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_person_reg_country_code2" :options="countries" label="display_text" :class="['form-control', typeof ap_persons2.ap_person_reg_country_code !== 'undefined' && ap_persons2.ap_person_reg_country_code.value!==''?'vs--selected':'']" @search=fetchCountries v-model="ap_persons2.ap_person_reg_country_code" :placeholder="$t('message.contracts.ap_person_reg_country_code')" @focus="country6_Focused" @blur="country6Blurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_person_reg_country_code2" class="form-label-group-label shorter">{{$t('message.contracts.ap_person_reg_country_code')}}</label> -->
        </span>
        <h5>{{ $t("message.contracts.ap_person_reg_country_code") }}</h5>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_send_rec_identity_card_code_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            :indata="ap_send_rec_identity_card_codes"
            :placeholder="
              $t('message.contracts.ap_send_rec_identity_card_code')
            "
            v-model="ap_send_rec.ap_send_rec_identity_card_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_send_rec_identity_card_code" :options="ap_send_rec_identity_card_codes" label="display_text" :class="['form-control', typeof ap_send_rec.ap_send_rec_identity_card_code !== 'undefined' && ap_send_rec.ap_send_rec_identity_card_code.value!==''?'vs--selected':'']" v-model="ap_send_rec.ap_send_rec_identity_card_code" :placeholder="$t('message.contracts.ap_send_rec_identity_card_code')" @focus="ap_send_rec_identity_card_code_Focused" @blur="ap_send_rec_identity_card_codeBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_send_rec_identity_card_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_send_rec_identity_card_code')}}</label> -->
        </span>
        <div class="row">
          <div class="col-md-4">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_send_rec.ap_send_rec_identity_card_series"
                :placeholder="
                  $t('message.contracts.ap_send_rec_identity_card_series')
                "
                autocomplete="off"
                style="cursor: auto"
                id="ap_send_rec_identity_card_series"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_send_rec_identity_card_series"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.ap_send_rec_identity_card_series")
                }}</label
              >
            </span>
          </div>
          <div class="col-md-8">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                type="text"
                class="form-control"
                v-model="ap_send_rec.ap_send_rec_identity_card_number"
                :placeholder="
                  $t('message.contracts.ap_send_rec_identity_card_number')
                "
                autocomplete="off"
                style="cursor: auto"
                id="ap_send_rec_identity_card_number"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_send_rec_identity_card_number"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.ap_send_rec_identity_card_number")
                }}</label
              >
            </span>
          </div>
        </div>
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <!-- <b-form-datepicker :locale="locale" v-model="ap_send_rec.ap_send_rec_identity_card_date" :placeholder="$t('message.contracts.ap_send_rec_identity_card_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="ap_send_rec_identity_card_date"></b-form-datepicker>
					<label  v-if="ap_send_rec.ap_send_rec_identity_card_date!=''"  for="ap_send_rec_identity_card_date" class="form-label-group-label shorter topped">{{$t('message.contracts.ap_send_rec_identity_card_date')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="ap_send_rec.ap_send_rec_identity_card_date = ' '"
            @blur="
              ap_send_rec.ap_send_rec_identity_card_date == ' '
                ? (ap_send_rec.ap_send_rec_identity_card_date = '')
                : (ap_send_rec.ap_send_rec_identity_card_date =
                    ap_send_rec.ap_send_rec_identity_card_date)
            "
            inputClass="form-control"
            v-model="ap_send_rec.ap_send_rec_identity_card_date"
            :placeholder="
              $t('message.contracts.ap_send_rec_identity_card_date')
            "
            :inputAttr="{ id: 'ap_send_rec_identity_card_date' }"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_send_rec_identity_card_date"
            class="form-label-group-label shorter"
            :class="
              ap_send_rec.ap_send_rec_identity_card_date != '' &&
              ap_send_rec.ap_send_rec_identity_card_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.ap_send_rec_identity_card_date") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_send_rec.ap_send_rec_organization_name"
            :placeholder="$t('message.contracts.ap_send_rec_organization_name')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_send_rec_organization_name"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_send_rec_organization_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_send_rec_organization_name") }}</label
          >
        </span>
      </b-tab>
      <b-tab
        :title="$t('message.contracts.document_epi_tab_4_short')"
        :title-link-attributes="{
          title: $t('message.contracts.document_epi_tab_4'),
        }"
      >
        <h4>{{ $t("message.contracts.ap_transportations_place_group") }}</h4>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_transp_information_type_code_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            :indata="ap_transp_information_type_codes"
            :placeholder="
              $t('message.contracts.ap_transp_information_type_code')
            "
            v-model="ap_transportations.ap_transp_information_type_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_transp_information_type_code" :options="ap_transp_information_type_codes" label="display_text" :class="['form-control', typeof ap_transportations.ap_transp_information_type_code !== 'undefined' && ap_transportations.ap_transp_information_type_code.value!==''?'vs--selected':'']" v-model="ap_transportations.ap_transp_information_type_code" :placeholder="$t('message.contracts.ap_transp_information_type_code')" @focus="ap_transp_information_type_code_Focused" @blur="ap_transp_information_type_codeBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_transp_information_type_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_transp_information_type_code')}}</label> -->
        </span>
        <v-select-popup
          type="customs_office"
          :placeholder="$t('message.contracts.ap_transp_customs_office')"
          v-model="ap_transportations.ap_transp_customs_office"
          :disabled="is_field_readonly"
        />
        <!-- <code-value :label="$t('message.contracts.ap_transp_customs_office')" :value_placeholder="$t('message.contracts.ap_transp_customs_office')" :code_placeholder="$t('message.contracts.ap_transp_customs_office_code')" type="customs_office" v-model="ap_transportations.ap_transp_customs_office" :readonly="is_field_readonly"></code-value> -->
        <!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group',  ap_transp_customs_office_focus?'focused':'']">
					<v-select id="ap_transp_customs_office" :options="customs_offices" label="display_text" :class="['form-control', typeof ap_transportations.ap_transp_customs_office !== 'undefined' && ap_transportations.ap_transp_customs_office.value!==''?'vs--selected':'']" v-model="ap_transportations.ap_transp_customs_office" :placeholder="$t('message.contracts.ap_transp_customs_office')" @search="fetchCustomsOffices" @focus="ap_transp_customs_office_Focused" @blur="ap_transp_customs_officeBlurred"></v-select>	
               		<label for="ap_transp_customs_office" class="form-label-group-label shorter">{{$t('message.contracts.ap_transp_customs_office')}}</label>
				</span> -->
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_transp_customs_country_code_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="
              $t('message.contracts.ap_transp_customs_country_code')
            "
            v-model="ap_transportations.ap_transp_customs_country_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_transp_customs_country_code" :options="countries" label="display_text" :class="['form-control', typeof ap_transportations.ap_transp_customs_country_code !== 'undefined' && ap_transportations.ap_transp_customs_country_code.value!==''?'vs--selected':'']" v-model="ap_transportations.ap_transp_customs_country_code" :placeholder="$t('message.contracts.ap_transp_customs_country_code')" @search=fetchCountries @focus="ap_transp_customs_country_code_Focused" @blur="ap_transp_customs_country_codeBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_transp_customs_country_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_transp_customs_country_code')}}</label> -->
        </span>
        <h4>
          {{ $t("message.contracts.ap_transportations_transport_group") }}
        </h4>
        <div class="togglebutton other mt-md-3 form-label-group required">
          <label class="control-label-sm">
            <span>{{
              $t("message.contracts.ap_transp_container_indicator")
            }}</span
            ><br /><br />
            <input
              type="checkbox"
              v-model="ap_transportations.ap_transp_container_indicator"
              :disabled="is_field_readonly"
            />
            <span class="toggle"></span>
            <span class="choise_2">{{ $t("message.yes") }}</span>
            <span class="choise_1">{{ $t("message.no") }}</span>
          </label>
        </div>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_transp_dispatch_country_code_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="
              $t('message.contracts.ap_transp_dispatch_country_code')
            "
            v-model="ap_transportations.ap_transp_dispatch_country_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_transp_dispatch_country_code" :options="countries" label="display_text" :class="['form-control', typeof ap_transportations.ap_transp_dispatch_country_code !== 'undefined' && ap_transportations.ap_transp_dispatch_country_code.value!==''?'vs--selected':'']" v-model="ap_transportations.ap_transp_dispatch_country_code" :placeholder="$t('message.contracts.ap_transp_dispatch_country_code')" @search=fetchCountries @focus="ap_transp_dispatch_country_code_Focused" @blur="ap_transp_dispatch_country_codeBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_transp_dispatch_country_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_transp_dispatch_country_code')}}</label> -->
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_transp_destination_country_code_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="
              $t('message.contracts.ap_transp_destination_country_code')
            "
            v-model="ap_transportations.ap_transp_destination_country_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_transp_dispatch_country_code" :options="countries" label="display_text" :class="['form-control', typeof ap_transportations.ap_transp_destination_country_code !== 'undefined' && ap_transportations.ap_transp_destination_country_code.value!==''?'vs--selected':'']" v-model="ap_transportations.ap_transp_destination_country_code" :placeholder="$t('message.contracts.ap_transp_destination_country_code')" @search=fetchCountries @focus="ap_transp_destination_country_code_Focused" @blur="ap_transp_destination_country_codeBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_transp_destination_country_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_transp_destination_country_code')}}</label> -->
        </span>
        <h4>{{ $t("message.contracts.ap_transportations_customs_group") }}</h4>
        <v-select-popup
          type="customs_office"
          :placeholder="$t('message.contracts.ap_transp_customs_office_code')"
          v-model="ap_transportations.ap_transp_customs_office_inout"
          :disabled="is_field_readonly"
        />
        <!-- <code-value :label="$t('message.contracts.ap_transp_customs_office')" :value_placeholder="$t('message.contracts.ap_transp_customs_office')" :code_placeholder="$t('message.contracts.ap_transp_customs_office_code')" type="customs_office" v-model="ap_transportations.ap_transp_customs_office_inout" :readonly="is_field_readonly"></code-value> -->
        <!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group',  ap_transp_customs_office_inout_focus?'focused':'']">
					<v-select id="ap_transp_customs_office_inout" :options="customs_offices" label="display_text" :class="['form-control', typeof ap_transportations.ap_transp_customs_office_inout !== 'undefined' && ap_transportations.ap_transp_customs_office_inout.value!==''?'vs--selected':'']" v-model="ap_transportations.ap_transp_customs_office_inout" :placeholder="$t('message.contracts.ap_transp_customs_office_inout')" @search="fetchCustomsOffices" @focus="ap_transp_customs_office_inout_Focused" @blur="ap_transp_customs_office_inoutBlurred"></v-select>	
               		<label for="ap_transp_customs_office_inout" class="form-label-group-label shorter">{{$t('message.contracts.ap_transp_customs_office_inout')}}</label>
				</span> -->
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_transp_customs_country_code_io_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="
              $t('message.contracts.ap_transp_customs_country_code_io')
            "
            v-model="ap_transportations.ap_transp_customs_country_code_io"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_transp_customs_country_code_io" :options="countries" label="display_text" :class="['form-control', typeof ap_transportations.ap_transp_customs_country_code_io !== 'undefined' && ap_transportations.ap_transp_customs_country_code_io.value!==''?'vs--selected':'']" v-model="ap_transportations.ap_transp_customs_country_code_io" :placeholder="$t('message.contracts.ap_transp_customs_country_code_io')" @search=fetchCountries @focus="ap_transp_customs_country_code_io_Focused" @blur="ap_transp_customs_country_code_ioBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_transp_customs_country_code_io" class="form-label-group-label shorter">{{$t('message.contracts.ap_transp_customs_country_code_io')}}</label> -->
        </span>
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <!-- <b-form-datepicker :locale="locale" v-model="ap_transportations.ap_transp_date_expected_arrival" :placeholder="$t('message.contracts.ap_transp_date_expected_arrival')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="ap_transp_date_expected_arrival"></b-form-datepicker>
					<label  v-if="ap_transportations.ap_transp_date_expected_arrival!=''"  for="ap_transp_date_expected_arrival" class="form-label-group-label shorter topped">{{$t('message.contracts.ap_transp_date_expected_arrival')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="ap_transportations.ap_transp_date_expected_arrival = ' '"
            @blur="
              ap_transportations.ap_transp_date_expected_arrival == ' '
                ? (ap_transportations.ap_transp_date_expected_arrival = '')
                : (ap_transportations.ap_transp_date_expected_arrival =
                    ap_transportations.ap_transp_date_expected_arrival)
            "
            inputClass="form-control"
            v-model="ap_transportations.ap_transp_date_expected_arrival"
            :placeholder="
              $t('message.contracts.ap_transp_date_expected_arrival')
            "
            :inputAttr="{ id: 'ap_transp_date_expected_arrival' }"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_transp_date_expected_arrival"
            class="form-label-group-label shorter"
            :class="
              ap_transportations.ap_transp_date_expected_arrival != '' &&
              ap_transportations.ap_transp_date_expected_arrival != null
                ? 'topped'
                : ''
            "
            >{{
              $t("message.contracts.ap_transp_date_expected_arrival")
            }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <b-form-timepicker
            :locale="locale"
            v-model="ap_transportations.ap_transp_date_expected_arrival_time"
            :placeholder="
              $t('message.contracts.ap_transp_date_expected_arrival_time')
            "
            size="sm"
            no-flip
            button-variant="link"
            :button-only="false"
            :no-close-button="true"
            :hide-header="true"
            :show-decade-nav="false"
            id="ap_transp_date_expected_arrival_time"
            :disabled="is_field_readonly"
          ></b-form-timepicker>
        </span>
        <h4>
          {{
            $t(
              "message.contracts.ap_transportations_transport_facilities_group",
            )
          }}
        </h4>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_transp_transport_mode_code_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="transport_mode_code"
            :placeholder="$t('message.contracts.ap_transp_transport_mode_code')"
            v-model="ap_transportations.ap_transp_transport_mode_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_transp_transport_mode_code" :options="transport_mode_codes" label="display_text" :class="['form-control', typeof ap_transportations.ap_transp_transport_mode_code !== 'undefined' && ap_transportations.ap_transp_transport_mode_code.value!==''?'vs--selected':'']" v-model="ap_transportations.ap_transp_transport_mode_code" :placeholder="$t('message.contracts.ap_transp_transport_mode_code')" @search="fetchTransportModeCodes" @focus="ap_transp_transport_mode_code_Focused" @blur="ap_transp_transport_mode_codeBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_transp_transport_mode_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_transp_transport_mode_code')}}</label> -->
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            ap_transp_transport_nationality_code_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="country"
            :placeholder="
              $t('message.contracts.ap_transp_transport_nationality_code')
            "
            v-model="ap_transportations.ap_transp_transport_nationality_code"
            :disabled="is_field_readonly"
          />

          <!-- <v-select id="ap_transp_transport_nationality_code" :options="countries" label="display_text" :class="['form-control', typeof ap_transportations.ap_transp_transport_nationality_code !== 'undefined' && ap_transportations.ap_transp_transport_nationality_code.value!==''?'vs--selected':'']" v-model="ap_transportations.ap_transp_transport_nationality_code" :placeholder="$t('message.contracts.ap_transp_transport_nationality_code')" @search=fetchCountries @focus="ap_transp_transport_nationality_code_Focused" @blur="ap_transp_transport_nationality_codeBlurred" :disabled="is_field_readonly"></v-select>	
               		<label for="ap_transp_transport_nationality_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_transp_transport_nationality_code')}}</label> -->
        </span>
        <h4>
          {{
            $t(
              "message.contracts.ap_transportations_transport_description_group",
            )
          }}
        </h4>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_transportations.ap_transp_vin"
            :placeholder="$t('message.contracts.ap_transp_vin')"
            autocomplete="off"
            style="cursor: auto"
            id="ap_transp_vin"
            :disabled="is_field_readonly"
          />
          <label for="ap_transp_vin" class="form-label-group-label shorter">{{
            $t("message.contracts.ap_transp_vin")
          }}</label>
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            maxlength="20"
            type="text"
            class="form-control"
            v-model="ap_transportations.ap_transp_transport_identifier"
            :placeholder="
              $t('message.contracts.ap_transp_transport_identifier')
            "
            autocomplete="off"
            style="cursor: auto"
            id="ap_transp_transport_identifier"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_transp_transport_identifier"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ap_transp_transport_identifier") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ap_transportations.ap_transp_active_transport_identifier"
            :placeholder="
              $t('message.contracts.ap_transp_active_transport_identifier')
            "
            autocomplete="off"
            style="cursor: auto"
            id="ap_transp_active_transport_identifier"
            :disabled="is_field_readonly"
          />
          <label
            for="ap_transp_active_transport_identifier"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.ap_transp_active_transport_identifier")
            }}</label
          >
        </span>
      </b-tab>
      <b-tab
        :title="$t('message.contracts.document_epi_tab_5_short')"
        :title-link-attributes="{
          title: $t('message.contracts.document_epi_tab_5'),
        }"
      >
        <h4>{{ $t("message.contracts.ap_good_data_group") }}</h4>
        <div id="products-table">
          <div class="input-group mb-3" style="width: 300px">
            <input
              class="form-control"
              type="text"
              v-model="looking_for_product_number"
              style="height: 32px"
              :placeholder="$t('message.contracts.search_by_number')"
            />
            <div class="input-group-append">
              <button
                @click="lookForProductByNumber"
                class="btn btn-sm btn-outline-success"
              >
                {{ $t("message.contracts.search_by_number_button") }}
              </button>
            </div>
          </div>

          <b-table
            responsive
            striped
            hover
            :tbody-tr-class="rowClass"
            :items="ap_good_data"
            :fields="product_fields"
            :per-page="3"
            :current-page="product_page"
          >
            <template v-slot:cell(index)="data">
              <strong>{{ data.index + 1 }}</strong>
            </template>
            <template v-slot:cell(ap_good_data_goods_tnved_code)="data">
              <strong>{{
                check_undefined_table(data.item.ap_good_data_goods_tnved_code)
                  .display_text
              }}</strong>
            </template>
            <template v-slot:cell(ap_good_data_origin_country_code)="data">
              <strong>{{
                check_undefined_table(
                  data.item.ap_good_data_origin_country_code,
                )
              }}</strong>
            </template>
            <template
              v-slot:cell(ap_good_data_delivery_terms_string_code)="data"
            >
              <strong>{{
                check_undefined_table(
                  data.item.ap_good_data_delivery_terms_string_code,
                )
              }}</strong>
            </template>
            <template v-slot:cell(ap_good_data_invoiced_cost)="data">
              <strong>{{ addThousandsSeparator(data.value, ",") }}</strong>
            </template>
            <template v-slot:cell(ap_good_data_statistical_cost)="data">
              <strong>{{ addThousandsSeparator(data.value, ",") }}</strong>
            </template>
            <template v-slot:cell(ap_good_data_customs_cost)="data">
              <strong>{{ addThousandsSeparator(data.value, ",") }}</strong>
            </template>
            <template v-slot:cell(ap_good_data_ext_measure)="data">
              {{ check_undefined_table(data.item.ap_good_data_ext_measure) }}
            </template>

            <template v-slot:cell(remove)="data">
              <button
                class="btn btn-sm btn-link text-info"
                @click="editProduct(product_page * 3 + data.index)"
              >
                <i class="fa fa-edit"></i></button
              ><button
                v-if="!is_field_readonly"
                class="btn btn-sm btn-link text-danger"
                @click="removeProduct(data.index)"
              >
                <i class="fa fa-times"></i>
              </button>
            </template>
          </b-table>
          <div class="d-flex justify-content-center">
            <b-pagination
              v-if="ap_good_data.length / 3 > 1"
              v-model="product_page"
              :total-rows="ap_good_data.length"
              :per-page="3"
            ></b-pagination>
          </div>
        </div>
        <transition name="slide">
          <div
            v-if="add_product || edit_product"
            class="add-product-block alert-success"
            style="margin: 0 -1.5em"
          >
            <span
              :class="[
                'bmd-form-group mb-1 d-block  form-label-group required',
              ]"
            >
              <input
                type="number"
                class="form-control"
                v-model="ap_good_data_single.ap_good_data_goods_numeric"
                :placeholder="
                  $t('message.contracts.ap_good_data_goods_numeric')
                "
                autocomplete="off"
                style="cursor: auto"
                id="ap_good_data_goods_numeric"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_good_data_goods_numeric"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_good_data_goods_numeric") }}</label
              >
            </span>
            <span
              :class="[
                'bmd-form-group mb-1 d-block  form-label-group required',
              ]"
            >
              <input
                type="number"
                class="form-control"
                v-model="ap_good_data_single.ap_good_data_list_numeric"
                :placeholder="$t('message.contracts.ap_good_data_list_numeric')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_good_data_list_numeric"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_good_data_list_numeric"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_good_data_list_numeric") }}</label
              >
            </span>
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="ap_good_data_single.ap_good_data_goods_description"
                :placeholder="
                  $t('message.contracts.ap_good_data_goods_description')
                "
                autocomplete="off"
                style="cursor: auto"
                id="ap_good_data_goods_description"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_good_data_goods_description"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.ap_good_data_goods_description")
                }}</label
              >
            </span>
            <div class="row">
              <div class="col-md-6">
                <span
                  :class="['bmd-form-group mb-1 d-block  form-label-group']"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="ap_good_data_single.ap_good_data_quant"
                    :placeholder="$t('message.contracts.ap_good_data_quant')"
                    autocomplete="off"
                    style="cursor: auto"
                    id="ap_good_data_quant"
                    :disabled="is_field_readonly"
                  />
                  <label
                    for="ap_good_data_quant"
                    class="form-label-group-label shorter"
                    >{{ $t("message.contracts.ap_good_data_quant") }}</label
                  >
                </span>
              </div>
              <div class="col-md-6">
                <span
                  :class="[
                    'bmd-form-group mb-1 d-block  form-label-group',
                    ap_good_data_ext_measure_f ? 'focused' : '',
                  ]"
                >
                  <v-select-popup
                    type="measure"
                    :placeholder="
                      $t('message.contracts.ap_good_data_ext_measure')
                    "
                    v-model="ap_good_data_single.ap_good_data_ext_measure"
                    :disabled="is_field_readonly"
                  />

                  <!-- <v-select id="ap_good_data_ext_measure" :options="measures" label="display_text" :class="['form-control', typeof ap_good_data_single.ap_good_data_ext_measure !== 'undefined' && ap_good_data_single.ap_good_data_ext_measure.value!==''?'vs--selected':'']" @search="fetchMeasures"  v-model="ap_good_data_single.ap_good_data_ext_measure" :placeholder="$t('message.contracts.ap_good_data_ext_measure')" @focus="ap_good_data_ext_measure_f=true" @blur="ap_good_data_ext_measure_f=false" :disabled="is_field_readonly"></v-select>
									 <label for="ap_good_data_ext_measure" class="form-label-group-label shorter">{{$t('message.contracts.ap_good_data_ext_measure')}}</label> -->
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <span :class="['bmd-form-group mb-1 d-block']">
                  <cleave
                    v-model="
                      ap_good_data_single.ap_good_data_gross_weight_quantity
                    "
                    :options="cleaveWeight"
                    class="form-control"
                    :placeholder="
                      $t('message.contracts.ap_good_data_gross_weight_quantity')
                    "
                    autocomplete="off"
                    style="cursor: auto"
                    :disabled="is_field_readonly"
                  ></cleave>
                </span>
              </div>
              <div class="col-md-6">
                <span :class="['bmd-form-group mb-1 d-block']">
                  <cleave
                    v-model="
                      ap_good_data_single.ap_good_data_net_weight_quantity
                    "
                    :options="cleaveWeight"
                    class="form-control"
                    :placeholder="
                      $t('message.contracts.ap_good_data_net_weight_quantity')
                    "
                    autocomplete="off"
                    style="cursor: auto"
                    :disabled="is_field_readonly"
                  ></cleave>
                </span>
              </div>
            </div>
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="ap_good_data_single.ap_good_data_container_num"
                :placeholder="
                  $t('message.contracts.ap_good_data_container_num')
                "
                autocomplete="off"
                style="cursor: auto"
                id="ap_good_data_container_num"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_good_data_container_num"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_good_data_container_num") }}</label
              >
            </span>
            <div class="row">
              <div class="col-md-4">
                <span :class="['bmd-form-group mb-1 d-block']">
                  <cleave
                    v-model="ap_good_data_single.ap_good_data_invoiced_cost"
                    :options="cleavePrice"
                    class="form-control"
                    :placeholder="
                      $t('message.contracts.ap_good_data_invoiced_cost')
                    "
                    autocomplete="off"
                    style="cursor: auto"
                    :disabled="is_field_readonly"
                  ></cleave>
                </span>
              </div>
              <div class="col-md-4">
                <span :class="['bmd-form-group mb-1 d-block']">
                  <cleave
                    v-model="ap_good_data_single.ap_good_data_customs_cost"
                    :options="cleavePrice"
                    class="form-control"
                    :placeholder="
                      $t('message.contracts.ap_good_data_customs_cost')
                    "
                    autocomplete="off"
                    style="cursor: auto"
                    :disabled="is_field_readonly"
                  ></cleave>
                </span>
              </div>
              <div class="col-md-4">
                <span :class="['bmd-form-group mb-1 d-block']">
                  <cleave
                    v-model="ap_good_data_single.ap_good_data_statistical_cost"
                    :options="cleavePrice"
                    class="form-control"
                    :placeholder="
                      $t('message.contracts.ap_good_data_statistical_cost')
                    "
                    autocomplete="off"
                    style="cursor: auto"
                    :disabled="is_field_readonly"
                  ></cleave>
                </span>
              </div>
            </div>
            <span
              :class="[
                'bmd-form-group mb-1 d-block  form-label-group',
                tnved_focused ? 'focused' : '',
              ]"
            >
              <tnved
                :placeholder="
                  $t('message.contracts.ap_good_data_goods_tnved_code')
                "
                :placeholder_name="$t('message.tnved_name')"
                :placeholder_code="$t('message.tnved_code')"
                v-model="ap_good_data_single.ap_good_data_goods_tnved_code"
                :disabled="is_field_readonly"
              ></tnved>
              <!-- <v-select id="ap_good_data_goods_tnved_code" :options="tnveds" label="display_text" :class="['form-control', typeof ap_good_data_single.ap_good_data_goods_tnved_code !== 'undefined' && ap_good_data_single.ap_good_data_goods_tnved_code.value!==''?'vs--selected':'']" @search="fetchTNVED"  v-model="ap_good_data_single.ap_good_data_goods_tnved_code" :placeholder="$t('message.contracts.ap_good_data_goods_tnved_code')" @focus="tnvedFocused" @blur="tnvedBlurred"></v-select> -->
              <!-- <label for="ap_good_data_goods_tnved_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_good_data_goods_tnved_code')}}</label> -->
            </span>
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                ap_good_data_origin_country_code_focus ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="country"
                :placeholder="
                  $t('message.contracts.ap_good_data_origin_country_code')
                "
                v-model="ap_good_data_single.ap_good_data_origin_country_code"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="ap_transp_transport_nationality_code" :options="countries" label="display_text" :class="['form-control', typeof ap_good_data_single.ap_good_data_origin_country_code !== 'undefined' && ap_good_data_single.ap_good_data_origin_country_code.value!==''?'vs--selected':'']" v-model="ap_good_data_single.ap_good_data_origin_country_code" :placeholder="$t('message.contracts.ap_good_data_origin_country_code')" @search=fetchCountries @focus="ap_good_data_origin_country_code_Focused" @blur="ap_good_data_origin_country_codeBlurred" :disabled="is_field_readonly"></v-select>	
		               		<label for="ap_good_data_origin_country_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_good_data_origin_country_code')}}</label> -->
            </span>
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                delivery_focused ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="delivery_term"
                :placeholder="
                  $t(
                    'message.contracts.ap_good_data_delivery_terms_string_code',
                  )
                "
                v-model="
                  ap_good_data_single.ap_good_data_delivery_terms_string_code
                "
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="ap_good_data_delivery_terms_string_code" :options="delivery_terms" label="display_text" :class="['form-control', ap_good_data_single.ap_good_data_delivery_terms_string_code.value!==''?'vs--selected':'']" @search="fetchDeliveryTerms"  v-model="ap_good_data_single.ap_good_data_delivery_terms_string_code" :placeholder="$t('message.contracts.ap_good_data_delivery_terms_string_code')" @focus="deliveryFocused" @blur="deliveryBlurred" :disabled="is_field_readonly"></v-select>
		                    <label for="ap_good_data_delivery_terms_string_code" class="form-label-group-label shorter">{{$t('message.contracts.ap_good_data_delivery_terms_string_code')}}</label> -->
            </span>
            <h5 class="text-dark">
              {{ $t("message.contracts.ap_good_data_places_group") }}
            </h5>
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="ap_good_data_single.ap_good_data_places"
                :placeholder="$t('message.contracts.ap_good_data_places')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_good_data_places"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_good_data_places"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_good_data_places") }}</label
              >
            </span>
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                ap_good_data_packet_f ? 'focused' : '',
              ]"
            >
              <v-select-popup
                :indata="ap_good_data_packets"
                :placeholder="$t('message.contracts.ap_good_data_packet')"
                v-model="ap_good_data_single.ap_good_data_packet"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="ap_good_data_delivery_terms_string_code" :options="ap_good_data_packets" label="display_text" :class="['form-control', ap_good_data_single.ap_good_data_packet.value!==''?'vs--selected':'']" v-model="ap_good_data_single.ap_good_data_packet" :placeholder="$t('message.contracts.ap_good_data_packet')" @focus="ap_good_data_packet_f=true" @blur="ap_good_data_packet_f=false" :disabled="is_field_readonly"></v-select>
		                    <label for="ap_good_data_packet" class="form-label-group-label shorter">{{$t('message.contracts.ap_good_data_packet')}}</label> -->
            </span>
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="ap_good_data_single.ap_good_data_places_name"
                :placeholder="$t('message.contracts.ap_good_data_places_name')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_good_data_places_name"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_good_data_places_name"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_good_data_places_name") }}</label
              >
            </span>

            <div v-if="add_product">
              <button
                class="btn btn-sm btn-success"
                @click="addProduct()"
                v-if="add_product && !is_field_readonly"
              >
                {{ $t("message.contracts.add_product") }}
              </button>
              <button
                class="btn btn-sm btn-danger btn-outline-danger float-right"
                @click="hideAddProduct()"
              >
                {{ $t("message.cancel") }}
              </button>
            </div>
            <div v-if="edit_product">
              <button
                class="btn btn-sm btn-success"
                @click="saveProduct()"
                v-if="edit_product && !is_field_readonly"
              >
                {{ $t("message.contracts.save_product") }}
              </button>
              <button
                class="btn btn-sm btn-danger btn-outline-danger float-right"
                @click="hideEditProduct()"
              >
                {{ $t("message.cancel") }}
              </button>
            </div>
          </div>
        </transition>
        <button
          class="btn btn-sm btn-success btn-outline-success mb-3"
          @click="showAddProduct()"
          v-if="!add_product && !is_field_readonly"
        >
          {{ $t("message.contracts.add_product") }}
        </button>
        <div v-if="!add_product && !is_field_readonly" class="form-group">
          <label for="excel-goods-import">{{
            $t("message.contracts.excel_import_gooods_label")
          }}</label>
          <input
            type="file"
            id="excel-goods-import"
            :disabled="files_loading"
            class="form-control"
            @change="importGoodsExcel($event, index)"
          />
        </div>
      </b-tab>
      <b-tab
        :title="$t('message.contracts.document_epi_tab_6_short')"
        :title-link-attributes="{
          title: $t('message.contracts.document_epi_tab_6'),
        }"
      >
        <h4>{{ $t("message.contracts.ap_prev_doc_group") }}</h4>
        <b-table
          responsive
          striped
          hover
          :items="ap_prev_docs"
          :fields="ap_prev_docs_fields"
        >
          <!--<template v-slot:cell(ap_good_data_goods_tnved_code)="data">
						<strong>{{ data.item.ap_good_data_goods_tnved_code.display_text }}</strong>
					</template>
					<template v-slot:cell(ap_good_data_origin_country_code)="data">
						<strong>{{ data.item.ap_good_data_origin_country_code.display_text }}</strong>
					</template>
					<template v-slot:cell(ap_good_data_delivery_terms_string_code)="data">
						<strong>{{ data.item.ap_good_data_delivery_terms_string_code.display_text }}</strong>
					</template>
					<template v-slot:cell(ap_good_data_invoiced_cost)="data">
						<strong>{{ addThousandsSeparator(data.value, ',') }}</strong>
					</template>
					<template v-slot:cell(ap_good_data_statistical_cost)="data">
						<strong>{{ addThousandsSeparator(data.value, ',') }}</strong>
					</template>
					<template v-slot:cell(ap_good_data_customs_cost)="data">
						<strong>{{ addThousandsSeparator(data.value, ',') }}</strong>
					</template>-->
          <template v-slot:cell(ap_prev_doc_kind)="data">
            <strong>{{ data.value.display_text }}</strong>
          </template>

          <template v-slot:cell(remove)="data">
            <button
              class="btn btn-sm btn-link text-info"
              @click="editDoc(data.index)"
            >
              <i class="fa fa-edit"></i></button
            ><button
              v-if="!is_field_readonly"
              class="btn btn-sm btn-link text-danger"
              @click="removeDoc(data.index)"
            >
              <i class="fa fa-times"></i>
            </button>
          </template>
        </b-table>
        <transition name="slide">
          <div
            v-if="add_doc || edit_doc"
            class="add-product-block alert-success"
            style="margin: 0 -1.5em"
          >
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <!-- <b-form-datepicker :locale="locale" v-model="ap_prev_doc.ap_prev_doc_preceding_document_date" :placeholder="$t('message.contracts.ap_prev_doc_preceding_document_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="ap_prev_doc_preceding_document_date"></b-form-datepicker>
							<label  v-if="ap_prev_doc.ap_prev_doc_preceding_document_date!=''"  for="ap_prev_doc_preceding_document_date" class="form-label-group-label shorter topped">{{$t('message.contracts.ap_prev_doc_preceding_document_date')}}</label> -->

              <datepicker
                value-type="YYYY-MM-DD"
                format="DD.MM.YYYY"
                @focus="ap_prev_doc.ap_prev_doc_preceding_document_date = ' '"
                @blur="
                  ap_prev_doc.ap_prev_doc_preceding_document_date == ' '
                    ? (ap_prev_doc.ap_prev_doc_preceding_document_date = '')
                    : (ap_prev_doc.ap_prev_doc_preceding_document_date =
                        ap_prev_doc.ap_prev_doc_preceding_document_date)
                "
                inputClass="form-control"
                v-model="ap_prev_doc.ap_prev_doc_preceding_document_date"
                :placeholder="
                  $t('message.contracts.ap_prev_doc_preceding_document_date')
                "
                :inputAttr="{ id: 'ap_prev_doc_preceding_document_date' }"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_prev_doc_preceding_document_date"
                class="form-label-group-label shorter"
                :class="
                  ap_prev_doc.ap_prev_doc_preceding_document_date != '' &&
                  ap_prev_doc.ap_prev_doc_preceding_document_date != null
                    ? 'topped'
                    : ''
                "
                >{{
                  $t("message.contracts.ap_prev_doc_preceding_document_date")
                }}</label
              >
            </span>
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="number"
                class="form-control"
                v-model="ap_prev_doc.ap_prev_doc_preceding_document_number"
                :placeholder="
                  $t('message.contracts.ap_prev_doc_preceding_document_number')
                "
                autocomplete="off"
                style="cursor: auto"
                id="ap_prev_doc_preceding_document_number"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_prev_doc_preceding_document_number"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.ap_prev_doc_preceding_document_number")
                }}</label
              >
            </span>
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="ap_prev_doc.ap_prev_doc_preceding_document_name"
                :placeholder="$t('message.contracts.ap_prev_doc_preceding_document_name')"
                autocomplete="off"
                style="cursor: auto"
                id="ap_prev_doc_preceding_document_name"
                :disabled="is_field_readonly"
              />
              <label
                for="ap_prev_doc_preceding_document_name"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.ap_prev_doc_preceding_document_name") }}</label
              >
            </span>
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group',
                ap_prev_doc_kind_f ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="custdoc_kind"
                :placeholder="$t('message.contracts.ap_prev_doc_kind')"
                v-model="ap_prev_doc.ap_prev_doc_kind"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="ap_good_data_delivery_terms_string_code" :options="custdoc_kinds" label="display_text" :class="['form-control', ap_prev_doc.ap_prev_doc_kind.value!==''?'vs--selected':'']" v-model="ap_prev_doc.ap_prev_doc_kind" :placeholder="$t('message.contracts.ap_prev_doc_kind')" @focus="ap_prev_doc_kind_f=true" @search="fetchCustdocKinds" @blur="ap_prev_doc_kind_f=false" :disabled="is_field_readonly"></v-select>
		                    <label for="ap_prev_doc_kind" class="form-label-group-label shorter">{{$t('message.contracts.ap_prev_doc_kind')}}</label> -->
            </span>

            <div v-if="add_doc">
              <button
                class="btn btn-sm btn-success"
                @click="addDoc()"
                v-if="add_doc && !is_field_readonly"
              >
                {{ $t("message.contracts.add_doc") }}
              </button>
              <button
                class="btn btn-sm btn-danger btn-outline-danger float-right"
                @click="hideAddDoc()"
              >
                {{ $t("message.cancel") }}
              </button>
            </div>
            <div v-if="edit_doc">
              <button
                class="btn btn-sm btn-success"
                @click="saveDoc()"
                v-if="edit_doc && !is_field_readonly"
              >
                {{ $t("message.contracts.save_doc") }}
              </button>
              <button
                class="btn btn-sm btn-danger btn-outline-danger float-right"
                @click="hideEditDoc()"
              >
                {{ $t("message.cancel") }}
              </button>
            </div>
          </div>
        </transition>
        <button
          class="btn btn-sm btn-success btn-outline-success"
          @click="showAddDoc()"
          v-if="!add_doc && !is_field_readonly"
        >
          {{ $t("message.contracts.add_doc") }}
        </button>
      </b-tab>
    </b-tabs>
    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px; margin: 0 3px;"
    >
      <div class="dropdown">
        <button
          v-if="!is_field_readonly"
          class="btn btn-outline-success btn-sm dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :disabled="is_utin"
        >
          {{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}&nbsp;&nbsp;
          <div
            class="loading loading-button"
            v-if="loading"
            style="
              border-top-width: 2px;
              border-top-color: #4caf50;
              top: 30px;
              right: -93px;
            "
          ></div>
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(false)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create"
                  : "message.contracts.document_save",
              )
            }}</a
          >
          <a
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(true)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create_validate"
                  : "message.contracts.document_save_validate",
              )
            }}</a
          >
          <a
            class="dropdown-item"
            style="color: #4caf50"
            v-if="!is_new"
            @click="submit_and_sign_dialog()"
            :disabled="buttons_loading"
            >{{ $t("message.contracts.submit_and_sign_button") }}</a
          >
        </div>
      </div>
      <!--<button class="btn btn-success float-left" @click="saveDocument(false)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button>
			<button class="btn btn-success float-left" @click="saveDocument(true)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create_validate':'message.contracts.document_save_validate')}}</button> -->
      <!-- <button class="btn btn-outline-success ml-auto d-block" :disabled=buttons_loading>{{$t('message.contracts.epi_to_xml')}}</button> -->
    </div>

    <b-modal
      id="modal-select-ecp-type-epi"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
import moment from "moment";
export default {
  props: ["goods", "contract_details", "document_id", "is_new", "document"],
  data() {
    return {
      loading: false,
      looking_for_product_number: "",
      files_loading: false,
      product_page: 0,
      current_tab: 0,
      show_code_sign_type: false,
      sign_with_code_code: "",
      buttons_loading: false,
      ap_good_data_ext_measure_f: false,
      ap_good_data_packet_f: false,
      ap_prev_doc_kind_f: false,
      add_doc: false,
      edit_doc: false,
      add_product: false,
      edit_product: false,
      currently_editing: false,
      form_error: false,
      product_error: false,
      currency_focused: false,
      placeholder_currency: false,
      buyer_focused: false,
      seller_focused: false,
      buyer2_focused: false,
      seller2_focused: false,
      tnved_focused: false,
      placeholder_tnved: false,
      placeholder_measure: false,
      measure_focused: false,
      placeholder_delivery: false,
      delivery_focused: false,
      country_focused: false,
      ap_good_data_origin_country_code_focus: false,
      currencies: [],
      measures: [],
      companies: [],
      countries: [],
      tnveds: [],
      okeds: [],
      delivery_terms: [],
      org_forms: [],
      code_types: [],
      code_eknps: [],
      oper_basises: [],
      oper_codes: [],
      customs_offices: [],
      transport_mode_codes: [],
      fm1_memb_subj_kinds: [],
      custdoc_kinds: [],
      is_fiz_lico: false,

      ap_send_rec_identity_card_code_focus: false,
      country1_focus: false,
      country2_focus: false,
      country3_focus: false,
      country4_focus: false,
      country5_focus: false,
      country6_focus: false,

      ap_transp_information_type_code_focus: false,
      ap_transp_customs_office_focus: false,
      ap_transp_customs_country_code_focus: false,
      ap_transp_dispatch_country_code_focus: false,
      ap_transp_destination_country_code_focus: false,
      ap_transp_customs_office_inout_focus: false,
      ap_transp_transport_mode_code_focus: false,
      ap_transp_transport_nationality_code_focus: false,
      ap_good_origin_country_name_focus: false,
      ap_main_transit_direction_code_focus: false,
      oked_focused: false,
      fm1_memb_founder_org_form_focus: false,
      percent_focused: false,
      fm1_memb_org_form_focus: false,
      fm1_memb_country_focus: false,
      fm1_memb_country2_focus: false,
      fm1_memb_subj_kind_focus: false,
      discount_focused: false,
      fm1_subj_org_form_focus: false,
      fm1_oper_code_type_focus: false,
      fm1_oper_eknp_focus: false,
      fm1_oper_currency_focus: false,
      fm1_oper_basis_focus: false,
      fm1_oper_code_focus: false,
      ap_transp_customs_country_code_io_focus: false,
      fm1_oper_1code_focus: false,
      fm1_oper_2code_focus: false,
      fm1_oper_3code_focus: false,

      fm1_main_reason_focus: false,
      fm1_main_form_state_focus: false,
      fm1_main_doc_kind_focus: false,

      cleave_12_digits: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [12],
      },
      cleavePQTY: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [8],
      },
      cleaveWeight: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },
      cleavePrice: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [20],
        numeralDecimalScale: 2,
      },
      ap_good_data_packets: [
        {
          display_text: this.$t("message.contracts.ap_good_data_packet_0"),
          value: 0,
        },
        {
          display_text: this.$t("message.contracts.ap_good_data_packet_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.ap_good_data_packet_2"),
          value: 2,
        },
      ],
      fm1_main_doc_kinds: [
        {
          display_text: this.$t("message.contracts.fm1_main_doc_kind_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_doc_kind_2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_doc_kind_3"),
          value: 3,
        },
      ],
      fm1_main_form_states: [
        {
          display_text: this.$t("message.contracts.fm1_main_form_state_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_form_state_2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_form_state_3"),
          value: 3,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_form_state_4"),
          value: 4,
        },
      ],
      fm1_main_reasons: [
        {
          display_text: this.$t("message.contracts.fm1_main_reason_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_reason_2"),
          value: 2,
        },
      ],
      fm1_main_subreasons: [
        {
          display_text: this.$t("message.contracts.fm1_main_reason_sub_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_reason_sub_2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_reason_sub_3"),
          value: 3,
        },
      ],
      fm1_members_members: [
        {
          display_text: this.$t("message.contracts.fm1_fm1_member_payer"),
          value: "1",
        },
        {
          display_text: this.$t("message.contracts.fm1_fm1_member_recipient"),
          value: "2",
        },
        {
          display_text: this.$t(
            "message.contracts.fm1_fm1_member_payer_representative",
          ),
          value: "3",
        },
        {
          display_text: this.$t(
            "message.contracts.fm1_fm1_member_recipient_representative",
          ),
          value: "4",
        },
        {
          display_text: this.$t(
            "message.contracts.fm1_fm1_member_face_in_name_of",
          ),
          value: "5",
        },
        {
          display_text: this.$t("message.contracts.fm1_fm1_member_beneficiary"),
          value: "6",
        },
      ],
      fm1_memb_types: [
        { display_text: this.$t("message.contracts.fm1_memb_type1"), value: 1 },
        { display_text: this.$t("message.contracts.fm1_memb_type2"), value: 2 },
        { display_text: this.$t("message.contracts.fm1_memb_type3"), value: 3 },
      ],
      fm1_memb_foreigns: [
        {
          display_text: this.$t("message.contracts.fm1_memb_foreign1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_foreign2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_foreign3"),
          value: 3,
        },
      ],
      fm1_memb_org_forms: [
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_3"),
          value: 3,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_4"),
          value: 4,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_5"),
          value: 5,
        },
      ],
      ap_send_rec_identity_card_codes: [
        {
          display_text: this.$t(
            "message.contracts.ap_send_rec_identitry_card_code_1",
          ),
          value: "1-паспорт",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_send_rec_identitry_card_code_2",
          ),
          value: "2-водительское удостоверение",
        },
      ],

      ap_main_transit_direction_codes: [
        {
          display_text: this.$t(
            "message.contracts.ap_main_transit_direction_code_1",
          ),
          value: "ИМ",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_main_transit_direction_code_2",
          ),
          value: "ЭК",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_main_transit_direction_code_3",
          ),
          value: "ТР",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_main_transit_direction_code_4",
          ),
          value: "ВТ",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_main_transit_direction_code_5",
          ),
          value: "ТС",
        },
      ],

      ap_transp_information_type_codes: [
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_11",
          ),
          value: "11",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_21",
          ),
          value: "21",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_25",
          ),
          value: "25",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_31",
          ),
          value: "31",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_41",
          ),
          value: "41",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_52",
          ),
          value: "52",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_60",
          ),
          value: "60",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_72",
          ),
          value: "72",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_91",
          ),
          value: "91",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_99",
          ),
          value: "99",
        },
        {
          display_text: this.$t(
            "message.contracts.ap_transp_information_type_code_80",
          ),
          value: "80",
        },
      ],
      ap_prev_docs_fields: [
        {
          key: "ap_prev_doc_preceding_document_date",
          label: this.$t(
            "message.contracts.ap_prev_doc_preceding_document_date",
          ),
          sortable: false,
        },
        {
          key: "ap_prev_doc_preceding_document_number",
          label: this.$t(
            "message.contracts.ap_prev_doc_preceding_document_number",
          ),
          sortable: false,
        },
        {
          key: "ap_prev_doc_preceding_document_name",
          label: this.$t("message.contracts.ap_prev_doc_preceding_document_name"),
          sortable: false,
        },
        {
          key: "ap_prev_doc_kind",
          label: this.$t("message.contracts.ap_prev_doc_kind"),
          sortable: false,
        },
        {
          key: "remove",
          label: "",
        },
      ],
      ap_members1: {
        ap_memb_organization_name: "",
        ap_memb_short_name: "",
        ap_memb_bin: "",
        ap_memb_itn: "",
        ap_member_postal_code: "",
        ap_member_country_name: { value: "" },
        ap_member_region: "",
        ap_member_city: "",
        ap_member_street_house: "",
      },
      ap_members2: {
        ap_memb_organization_name: "",
        ap_memb_short_name: "",
        ap_memb_bin: "",
        ap_memb_itn: "",
        ap_member_postal_code: "",
        ap_member_country_name: { value: "" },
        ap_member_region: "",
        ap_member_city: "",
        ap_member_street_house: "",
      },
      ap_members3: {
        ap_memb_organization_name: "",
        ap_memb_short_name: "",
        ap_memb_bin: "",
        ap_memb_itn: "",
        ap_member_postal_code: "",
        ap_member_country_name: { value: "" },
        ap_member_region: "",
        ap_member_city: "",
        ap_member_street_house: "",
      },
      ap_members4: {
        ap_memb_organization_name: "",
        ap_memb_short_name: "",
        ap_memb_bin: "",
        ap_memb_itn: "",
        ap_member_postal_code: "",
        ap_member_country_name: { value: "" },
        ap_member_region: "",
        ap_member_city: "",
        ap_member_street_house: "",
      },
      ap_members5: {
        ap_memb_organization_name: "",
        ap_memb_short_name: "",
        ap_memb_bin: "",
        ap_memb_itn: "",
        ap_member_postal_code: "",
        ap_member_country_name: { value: "" },
        ap_member_region: "",
        ap_member_city: "",
        ap_member_street_house: "",
      },
      ap_persons: {
        ap_person_person_surname: "",
        ap_person_person_name: "",
        ap_person_person_middle_name: "",
        ap_person_person_post: "",
        ap_person_contact_phone: "",
      },
      ap_persons2: {
        ap_person_person_surname: "",
        ap_person_person_name: "",
        ap_person_person_middle_name: "",
        ap_person_person_post: "",
        ap_person_reg_country_code: { value: "" },
      },
      ap_send_rec: {
        ap_send_rec_identity_card_code: { value: "" },
        ap_send_rec_identity_card_series: "",
        ap_send_rec_identity_card_number: "",
        ap_send_rec_identity_card_date: "",
        ap_send_rec_organization_name: "",
      },
      ap_goods: {
        ap_good_origin_country_name: { value: "" },
        ap_good_specification_number: "",
        ap_good_specification_list_number: "",
        ap_good_total_goods_number: "",
        ap_good_total_package_number: "",
        ap_good_total_sheet_number: "",
        ap_good_total_cust_cost: "",
        ap_good_cust_cost_currency_code: { value: "" },
      },
      ap_main: {
        ap_main_decl_num: "",
        ap_main_reg_num: "",
        ap_main_decl_date: "",
        ap_main_country_code: { value: "" },
        ap_main_reg_date: "",
        ap_main_trans_kind_code: "01;06;14",
        ap_main_transit_direction_code: { value: "" },
        ap_main_electronic_document_sign: false,
        ap_main_carnet: false,
        ap_main_declaration_kind: { value: "" },
        ap_main_subsoil_sign: "",
        ap_main_seal_number: "",
        ap_main_seal_quantity: "",
        ap_main_language_cuesad: "",
        ap_main_recipient_country_code: { value: "" },
        ap_main_movement_code: { value: "" },
        SignDate: "",
        SignatureType: "",
        SignatureName: "",
        IsSigned: false,
        ap_astana_utin: "",
      },
      ap_transportations: {
        ap_transp_information_type_code: { value: "" },
        ap_transp_customs_office: { value: "" },
        ap_transp_customs_country_code: { value: "" },
        ap_transp_container_indicator: "",
        ap_transp_dispatch_country_code: { value: "" },
        ap_transp_destination_country_code: { value: "" },
        ap_transp_customs_office_inout: { value: "" },
        ap_transp_customs_country_code_io: { value: "" },
        ap_transp_date_expected_arrival: "",
        ap_transp_date_expected_arrival_time: "",
        ap_transp_transport_mode_code: { value: "" },
        ap_transp_transport_nationality_code: { value: "" },
        ap_transp_vin: "",
        ap_transp_transport_identifier: "",
        ap_transp_active_transport_identifier: "",
      },
      ap_good_data_single: {
        ap_good_data_goods_numeric: "",
        ap_good_data_list_numeric: "",
        ap_good_data_goods_description: "",
        ap_good_data_quant: "",
        ap_good_data_ext_measure: { value: "", display_text: "" },
        ap_good_data_gross_weight_quantity: "",
        ap_good_data_net_weight_quantity: "",
        ap_good_data_container_num: "",
        ap_good_data_invoiced_cost: "",
        ap_good_data_customs_cost: "",
        ap_good_data_statistical_cost: "",
        ap_good_data_goods_tnved_code: { value: "" },
        ap_good_data_origin_country_code: { value: "" },
        ap_good_data_delivery_terms_string_code: { value: "" },
        ap_good_data_places: "",
        ap_good_data_packet: { value: "" },
        ap_good_data_places_name: "",
      },
      ap_good_data: [],
      ap_prev_doc: {
        ap_prev_doc_preceding_document_date: "",
        ap_prev_doc_preceding_document_number: "",
        ap_prev_doc_preceding_document_name: "",
        ap_prev_doc_kind: { value: "" },
      },
      ap_prev_docs: [],
      fm1_main: {
        fm1_main_related_number: "",
        fm1_main_related_date: "",
        fm1_main_date: "",
        fm1_main_doc_kind: { value: "" },
        fm1_main_form_state: { value: "" },
        fm1_main_reason: { value: "" },
        fm1_main_subreason: { value: "" },
      },

      fm1_subject: {
        fm1_subj_code: "",
        fm1_subj_org_form: { value: "" },
        fm1_subj_name: "",
        fm1_subj_pers_second_name: "",
        fm1_subj_pers_name: "",
        fm1_subj_pers_middle_name: "",
        fm1_subj_rnn: "",
        fm1_subj_iin_bin: "",
        fm1_subj_manager_second_name: "",
        fm1_subj_manager_name: "",
        fm1_subj_manager_patronymic: "",
        fm1_subj_position: "",
        fm1_subj_phone: "",
        fm1_subj_email: "",
      },
      fm1_addrr: {
        state_kaz: "",
        region_kaz: "",
        sity_kaz: "",
        street: "",
        house_num: "",
        flat_num: "",
        post_index: "",
      },
      fm1_docs: {
        doc_num: "",
        doc_series: "",
        goverm_office: "",
        doc_date: "",
      },

      fm1_oper: {
        fm1_oper_number: "",
        fm1_oper_code_type: { value: "" },
        fm1_oper_eknp: { value: "" },
        fm1_oper_members_quant: "",
        fm1_oper_currency: { value: "" },
        fm1_oper_curr_code: "",
        fm1_oper_tenge_sum: "",
        fm1_oper_basis: { value: "" },

        fm1_oper_basis_doc_date: "",
        fm1_oper_basis_doc_num: "",
        fm1_oper_1code: { value: "" },
        fm1_oper_2code: { value: "" },
        fm1_oper_3code: { value: "" },
        fm1_oper_trouble_desc: "",
        fm1_oper_add_info: "",
      },
      fm1_members: {
        fm1_member: [],
        fm1_memb_is_subj: false,
        fm1_memb_subj_kind: { value: "" },
        fm1_memb_country: { value: "" },
        fm1_memb_type: "",
        fm1_memb_foreign: "",
        fm1_memb_bank_branch_place: "",
        fm1_memb_bank_branch: "",
        fm1_memb_sdp: "",
        fm1_memb_branch_code: "",
        fm1_memb_acc: "",
        fm1_memb_bank_place: "",
        fm1_memb_bank_name: "",
        fm1_memb_org_form: { value: "" },
        fm1_memb_company_name: "",
        fm1_memb_noname: "",
        fm1_memb_founder_org_form: { value: "" },
        fm1_memb_founder_: "",
        fm1_memb_founder_secondname: "",
        fm1_memb_founder_name: "",
        fm1_memb_founder_patronymic: "",
        fm1_memb_country_2: { value: "" },
        oked: { value: "" },
        iin_bin: "",
      },
      fm1_persons: {
        fm1_person_secondname: "",
        fm1_person_name: "",
        fm1_person_midle_name: "",
        fm1_person_secondname_2: "",
        fm1_person_name_2: "",
        fm1_person_middle_name_2: "",
        fm1_person_birth_date: "",
        fm1_person_birth_place: "",
      },
      fm1_docs2: {
        doc_type: "",
        doc_num: "",
        doc_series: "",
        goverm_office: "",
        doc_date: "",
      },
      fm1_addrr2: {
        state_kaz: "",
        region_kaz: "",
        sity_kaz: "",
        street: "",
        house_num: "",
        flat_num: "",
        post_index: "",
        fm1_memb_contact_phone: "",
        fm1_memb_email: "",
      },
      fm1_addrr3: {
        state_kaz: "",
        region_kaz: "",
        sity_kaz: "",
        street: "",
        house_num: "",
        flat_num: "",
        post_index: "",
        fm1_memb_memb_add_info: "",
      },

      CMR: {
        cmr_number: "",
        cmr_date: "",
        cmr_sender: { display_text: "", value: "" },
        cmr_recipient: { display_text: "", value: "" },
        cmr_courier: { display_text: "", value: "" },
        cmr_courier_next: { display_text: "", value: "" },
        cmr_track: "",
        cmr_trailer: "",
      },

      ContractDeliveryTerms: {
        DeliveryPlace: "",
        DeliveryTermsStringCode: { display_text: "", value: "" },
        TermsDescription: "",
      },

      TakingCargoPlace: {
        CountryCode: { display_text: "", value: "" },
        City: "",
        StreetHouse: "",
        PostalCode: "",
        TakingCargoDate: "",
      },

      EnclosedDocument: {
        PrDocumentName: "",
        PrDocumentNumber: "",
        PrDocumentDate: "",
      },
      CMRGoods: [],
      CMRGood: {
        GoodsMarking: "",
        GoodsQuantity: "",
        GoodsDescription: "",
        GoodsNomenclatureCode: { display_text: "", value: "" },
        GrossWeightQuantity: "",
        VolumeQuantity: "",
      },

      usage_codes: [],
      declaration_kinds: [],
      goods_transfer_features: [],

      ap_main_trans_kind_code_focus: false,
      ap_main_declaration_kinds_focus: false,
      ap_main_movement_code_focus: false,

      ConsigneeCustoms: {
        WarehouseName: "",
      },
      product_fields: [
        {
          key: "good_no",
          label: this.$t("message.contracts.product_number"),
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_group"),
          key: "ap_good_data_group",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_goods_numeric"),
          key: "ap_good_data_goods_numeric",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_list_numeric"),
          key: "ap_good_data_list_numeric",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_goods_description"),
          key: "ap_good_data_goods_description",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_quant"),
          key: "ap_good_data_quant",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_ext_measure"),
          key: "ap_good_data_ext_measure",
          sortable: false,
        },
        {
          label: this.$t(
            "message.contracts.ap_good_data_gross_weight_quantity",
          ),
          key: "ap_good_data_gross_weight_quantity",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_net_weight_quantity"),
          key: "ap_good_data_net_weight_quantity",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_container_num"),
          key: "ap_good_data_container_num",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_invoiced_cost"),
          key: "ap_good_data_invoiced_cost",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_customs_cost"),
          key: "ap_good_data_customs_cost",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_statistical_cost"),
          key: "ap_good_data_statistical_cost",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_goods_tnved_code"),
          key: "ap_good_data_goods_tnved_code",
          sortable: false,
        },
        {
          label: this.$t("message.contracts.ap_good_data_origin_country_code"),
          key: "ap_good_data_origin_country_code",
          sortable: false,
        },
        {
          label: this.$t(
            "message.contracts.ap_good_data_delivery_terms_string_code",
          ),
          key: "ap_good_data_delivery_terms_string_code",
          sortable: false,
        },
        {
          key: "remove",
          label: "",
        },
      ],
    };
  },
  methods: {
    /**
     * determines if the row should be highlighted
     */
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (parseInt(item.good_no) === parseInt(this.looking_for_product_number))
        return "table-success";
    },
    /**
     * looks for product in the grid by its guid
     */
    lookForProductByNumber() {
      let index =
        this.ap_good_data.findIndex(
          (good) =>
            parseInt(good.good_no) == parseInt(this.looking_for_product_number),
        ) + 1;
      if (!index) index = this.looking_for_product_number;

      const page = Math.ceil(index / 3);
      this.product_page = page;
    },
    /**
     * finds absolute position of the element
     */
    findPos(obj) {
      var curleft = 0;
      var curtop = 0;

      if (obj.offsetParent) {
        do {
          curleft += obj.offsetLeft;
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));

        return { X: curleft, Y: curtop };
      }
    },
    /**
     * replaces data-name of the field with field ID for validation purposes
     */
    field_name_replace(input) {
      let replaces = {
        attis_contract_desc: "ap_goods.ap_good_total_package_number",
        attis_contract_subject: "contract_subject",
      };
      return replaces[input];
    },
    /**
     * Navigates user to the field with error
     */
    go_to_error(error) {
      // switch(error.Subsection){
      // 	case 'Invoice':
      if (error.Subsection == "Epi" && error.Id == this.document_id) {
        switch (error.Value) {
          case "sum(pkglist_goods.placegoodsquantity) <> ap_goods.ap_good_total_package_number":
            this.current_tab = 1;
            setTimeout(() => {
              var element = document.querySelector(
                "#ap_good_total_package_number",
              );
              var element_pos = this.findPos(element);
              element.parentNode.classList.add("error");
              element.querySelector("input").focus();
              document
                .querySelector("#modal-document")
                .scrollTo(0, element_pos.Y - 50);
            }, 500);
            break;
          case "sum(InvoiceGoods.GrossWeightQuantity) <> ap_goods.ap_good_data_gross_weight_quantity":
          case "sum(ap_good_data.*) <> sum (CMRGoods.*)":
            this.current_tab = 4;
            var element = document.querySelector("#products-table");
            var element_pos = this.findPos(element);
            element.classList.add("error");
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "ap_goods.ap_good_total_goods_number <> count (InvoiceGoods.GoodsCode)":
            this.current_tab = 1;
            setTimeout(() => {
              var element = document.querySelector(
                "#ap_good_total_goods_number",
              );
              var element_pos = this.findPos(element);
              element.parentNode.classList.add("error");
              element.focus();
              document
                .querySelector("#modal-document")
                .scrollTo(0, element_pos.Y - 50);
            }, 500);
            break;
        }
      } else {
        setTimeout(() => {
          this.$root.$emit("process_contract_error", error);
        }, 500);
      }
    },

    fetchCustdocKinds(search, loading) {
      this.getLibrary("custdoc_kind", search, 10000);
    },
    fetchTransKinds(search, loading) {
      this.getLibrary("usage_code", search, 10000);
    },
    fetchDeclarationKinds(search, loading) {
      this.getLibrary("declaration_kind", search, 10000);
    },
    fetchMovementCodes(search, loading) {
      this.getLibrary("goods_transfer_feature", search, 10000);
    },
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-epi");
    },
    check_undefined_table(field) {
      if (field && typeof field.display_text !== "undefined") {
        return field.display_text;
      }
      return "";
    },
    signDocument() {
      this.loading = true;
      axios
        .get(window.base + "/document/LoadEpiXML?id=" + this.document_id)
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      let name = response.data.cert_name;
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature_name", name);
                      fd.append("signature", value);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-epi");
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-epi");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-cmr')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-cmr')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(window.base + "/document/LoadEpiXML?id=" + this.document_id)
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-epi");
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-epi");
                  });
              });
          });
      }
    },
    ap_main_trans_kind_code_Focused() {
      this.ap_main_trans_kind_code_focus = true;
    },
    ap_main_declaration_kind_Focused() {
      this.ap_main_declaration_kinds_focus = true;
    },
    ap_main_movement_code_Focused() {
      this.ap_main_movement_code_focus = true;
    },

    ap_main_trans_kind_codeBlurred() {
      this.ap_main_trans_kind_code_focus = false;
    },
    ap_main_declaration_kindBlurred() {
      this.ap_main_declaration_kinds_focus = false;
    },
    ap_main_movement_codeBlurred() {
      this.ap_main_movement_code_focus = false;
    },

    fetchCustomsOffices(search, loading) {
      this.getLibrary("customs_office", search, 10000);
    },
    fetchTransportModeCodes(search, loading) {
      this.getLibrary("transport_mode_code", search, 10000);
    },
    fetchMembSubjKind(search, loading) {
      this.getLibrary("fm1_memb_subj_kind", search, 10000);
    },
    addCourier() {
      this.$bvModal.show("modal-add-courier");
    },
    addCourierNext() {
      this.$bvModal.show("modal-add-courier-next");
    },
    addSender() {
      this.$bvModal.show("modal-add-sender");
    },
    addRecipient() {
      this.$bvModal.show("modal-add-recipient");
    },
    findLibValueProduct(lib, value, field, index) {
      let found = false;
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=10000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value.trim() == value.trim()) {
                this.$set(this.ap_good_data[index], field, item);
                found = true;
              }
            });
          });
      }
      if (!found) {
        this.$set(this.ap_good_data[index], field, {
          value: value.trim(),
          display_text: value.trim(),
        });
      }
    },
    findLibValue(lib, value, field) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value.trim() == value.trim()) {
                item.display_text = item.display_text;
                this.$set(this.ap_main, field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value == value) this.$set(this.ap_main, field, item);
        });
      }
    },
    addThousandsSeparator(n, thousandsSeparatorSymbol) {
      return new Intl.NumberFormat(this.locale).format(n);
    },
    saveProduct() {
      /*this.$v.$touch('CMRGood')
				if (this.$v.CMRGood.$invalid) {
					this.product_error = true
					setTimeout(()=>{
						$('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
					}, 100)
					
				} else {
					this.product_error = false*/
      this.hideEditProduct();
      // }
    },
    hideEditProduct() {
      this.ap_good_data_single = {
        ap_good_data_goods_numeric: "",
        ap_good_data_list_numeric: "",
        ap_good_data_goods_description: "",
        ap_good_data_quant: "",
        ap_good_data_ext_measure: { value: "", display_text: "" },
        ap_good_data_gross_weight_quantity: "",
        ap_good_data_net_weight_quantity: "",
        ap_good_data_container_num: "",
        ap_good_data_invoiced_cost: "",
        ap_good_data_customs_cost: "",
        ap_good_data_statistical_cost: "",
        ap_good_data_goods_tnved_code: { value: "" },
        ap_good_data_origin_country_code: { value: "" },
        ap_good_data_delivery_terms_string_code: { value: "" },
        ap_good_data_places_name: "",
        ap_good_data_places: "",
        ap_good_data_packet: { value: "" },
      };
      this.edit_product = false;
    },
    editProduct(index) {
      this.edit_product = true;
      let tmp = this.ap_good_data[index];
      if (
        typeof tmp.ap_good_data_ext_measure == "undefined" ||
        typeof tmp.ap_good_data_ext_measure.value == "undefined"
      )
        tmp.ap_good_data_ext_measure = { value: "", display_text: "" };

      if (
        typeof tmp.ap_good_data_packet == "undefined" ||
        typeof tmp.ap_good_data_packet.value == "undefined"
      )
        tmp.ap_good_data_packet = { value: "", display_text: "" };

      this.ap_good_data_single = tmp;
      this.currently_editing = index;
    },
    removeProduct(index) {
      this.ap_good_data.splice(index, 1);
    },
    addProduct() {
      // this.$v.$touch('CMRGood')
      /*if (this.$v.CMRGood.$invalid) {
					this.product_error = true
					setTimeout(()=>{
						$('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
					}, 100)
					
				} else {*/
      this.product_error = false;
      this.ap_good_data.push({
        good_no: this.ap_good_data.length + 1,
        ap_good_data_goods_numeric:
          this.ap_good_data_single.ap_good_data_goods_numeric,
        ap_good_data_list_numeric:
          this.ap_good_data_single.ap_good_data_list_numeric,
        ap_good_data_goods_description:
          this.ap_good_data_single.ap_good_data_goods_description,
        ap_good_data_quant: this.ap_good_data_single.ap_good_data_quant,
        ap_good_data_ext_measure:
          this.ap_good_data_single.ap_good_data_ext_measure,
        ap_good_data_container_num:
          this.ap_good_data_single.ap_good_data_container_num,
        ap_good_data_gross_weight_quantity:
          this.ap_good_data_single.ap_good_data_gross_weight_quantity,
        ap_good_data_net_weight_quantity:
          this.ap_good_data_single.ap_good_data_net_weight_quantity,
        ap_good_data_invoiced_cost:
          this.ap_good_data_single.ap_good_data_invoiced_cost,
        ap_good_data_customs_cost:
          this.ap_good_data_single.ap_good_data_customs_cost,
        ap_good_data_statistical_cost:
          this.ap_good_data_single.ap_good_data_statistical_cost,
        ap_good_data_goods_tnved_code:
          this.ap_good_data_single.ap_good_data_goods_tnved_code,
        ap_good_data_origin_country_code:
          this.ap_good_data_single.ap_good_data_origin_country_code,
        ap_good_data_delivery_terms_string_code:
          this.ap_good_data_single.ap_good_data_delivery_terms_string_code,
        ap_good_data_places: this.ap_good_data_single.ap_good_data_places,
        ap_good_data_packet: this.ap_good_data_single.ap_good_data_packet,
        ap_good_data_places_name:
          this.ap_good_data_single.ap_good_data_places_name,
      });
      this.hideAddProduct();

      //}
    },
    showAddProduct() {
      this.add_product = true;
    },
    hideAddProduct() {
      this.add_product = false;
      this.ap_good_data_single = {
        ap_good_data_goods_numeric: "",
        ap_good_data_list_numeric: "",
        ap_good_data_goods_description: "",
        ap_good_data_quant: "",
        ap_good_data_ext_measure: { value: "", display_text: "" },
        ap_good_data_container_num: "",
        ap_good_data_gross_weight_quantity: "",
        ap_good_data_net_weight_quantity: "",
        ap_good_data_invoiced_cost: "",
        ap_good_data_customs_cost: "",
        ap_good_data_statistical_cost: "",
        ap_good_data_goods_tnved_code: { value: "" },
        ap_good_data_origin_country_code: { value: "" },
        ap_good_data_delivery_terms_string_code: { value: "" },
        ap_good_data_places_name: "",
        ap_good_data_places: "",
        ap_good_data_packet: { value: "" },
      };
    },
    hideEditDoc() {
      this.ap_prev_doc = {
        ap_prev_doc_preceding_document_date: "",
        ap_prev_doc_preceding_document_number: "",
        ap_prev_doc_preceding_document_name: "",
        ap_prev_doc_kind: { value: "" },
      };
      this.edit_doc = false;
    },
    removeDoc(index) {
      this.ap_prev_docs.splice(index, 1);
    },
    saveDoc() {
      this.hideEditDoc();
    },
    editDoc(index) {
      this.edit_doc = true;
      this.ap_prev_doc = this.ap_prev_docs[index];
      this.currently_editing_doc = index;
    },
    addDoc() {
      this.ap_prev_docs.push({
        ap_prev_doc_preceding_document_date:
          this.ap_prev_doc.ap_prev_doc_preceding_document_date,
        ap_prev_doc_preceding_document_number:
          this.ap_prev_doc.ap_prev_doc_preceding_document_number,
        ap_prev_doc_preceding_document_name: this.ap_prev_doc.ap_prev_doc_preceding_document_name,
        ap_prev_doc_kind: this.ap_prev_doc.ap_prev_doc_kind,
      });
      this.hideAddDoc();
    },
    showAddDoc() {
      this.add_doc = true;
    },
    hideAddDoc() {
      this.add_doc = false;
      this.ap_prev_doc = {
        ap_prev_doc_preceding_document_date: "",
        ap_prev_doc_preceding_document_number: "",
        ap_prev_doc_preceding_document_name: "",
        ap_prev_doc_kind: { value: "" },
      };
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········")
              if (
                type == "usage_code" ||
                type == "declaration_kind" ||
                type == "goods_transfer_feature"
              ) {
                item.display_text = /*item.value+' - '+*/ item.display_text;
                this.$data[var_name].push(item);
              } else this.$data[var_name].push(item);
          });
        });
    },
    fetchCurrency(search, loading) {
      this.getLibrary("currency", search, 10000);
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    fetchTNVED(search, loading) {
      this.getLibrary("tnved", search, 10000);
    },
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 10000);
    },
    fetchCurrencies() {
      this.getLibrary("currency", "", 10000);
    },
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 10000);
    },
    fetchorg_form(search, loading) {
      this.getLibrary("org_form", search, 10000);
    },
    fetchFm1CodeType() {
      this.getLibrary("code_type", "", 10000);
    },
    fetchFm1CodeEknp() {
      this.getLibrary("code_eknp", "", 10000);
    },
    fetchFm1OperBasis() {
      this.getLibrary("oper_basis", "", 10000);
    },
    fetchFm1OperCode() {
      this.getLibrary("oper_code", "", 10000);
    },
    fm1_subj_org_form_Focused() {
      this.fm1_subj_org_form_focus = true;
    },
    fm1_subj_org_formBlurred() {
      this.fm1_subj_org_form_focus = false;
    },
    fm1_oper_code_type_Focused() {
      this.fm1_oper_code_type_focus = true;
    },
    fm1_oper_code_typeBlurred() {
      this.fm1_oper_code_type_focus = false;
    },
    ap_transp_customs_country_code_io_Focused() {
      this.ap_transp_customs_country_code_io_focus = true;
    },
    ap_transp_customs_country_code_ioBlurred() {
      this.ap_transp_customs_country_code_io_focus = false;
    },

    fm1_oper_eknp_Focused() {
      this.fm1_oper_eknp_focus = true;
    },
    fm1_oper_eknpBlurred() {
      this.fm1_oper_eknp_focus = false;
    },
    fm1_oper_basis_Focused() {
      this.fm1_oper_basis_focus = true;
    },
    fm1_oper_basisBlurred() {
      this.fm1_oper_basis_focus = false;
    },
    fm1_oper_1code_Focused() {
      this.fm1_oper_1code_focus = true;
    },
    fm1_oper_1codeBlurred() {
      this.fm1_oper_1code_focus = false;
    },
    fm1_oper_2code_Focused() {
      this.fm1_oper_2code_focus = true;
    },
    fm1_oper_2codeBlurred() {
      this.fm1_oper_2code_focus = false;
    },
    fm1_oper_3code_Focused() {
      this.fm1_oper_3code_focus = true;
    },
    fm1_oper_3codeBlurred() {
      this.fm1_oper_3code_focus = false;
    },
    fm1_memb_country2_Focused() {
      this.fm1_memb_country2_focus = true;
    },
    fm1_memb_country2Blurred() {
      this.fm1_memb_country2_focus = false;
    },
    ap_transp_information_type_code_Focused() {
      this.ap_transp_information_type_code_focus = true;
    },
    ap_transp_information_type_codeBlurred() {
      ap_transp_information_type_code_focus = false;
    },
    ap_transp_customs_office_Focused() {
      this.ap_transp_customs_office_focus = true;
    },
    ap_transp_customs_officeBlurred() {
      ap_transp_customs_office_focus = false;
    },
    ap_transp_customs_country_code_Focused() {
      this.ap_transp_customs_country_code_focus = true;
    },
    ap_transp_customs_country_codeBlurred() {
      ap_transp_customs_country_code_focus = false;
    },
    ap_transp_dispatch_country_code_Focused() {
      this.ap_transp_dispatch_country_code_focus = true;
    },
    ap_transp_dispatch_country_codeBlurred() {
      ap_transp_dispatch_country_code_focus = false;
    },
    ap_transp_destination_country_code_Focused() {
      this.ap_transp_destination_country_code_focus = true;
    },
    ap_transp_destination_country_codeBlurred() {
      ap_transp_destination_country_code_focus = false;
    },
    ap_transp_customs_office_inout_Focused() {
      this.ap_transp_customs_office_inout_focus = true;
    },
    ap_transp_customs_office_inoutBlurred() {
      ap_transp_customs_office_inout_focus = false;
    },
    ap_transp_transport_mode_code_Focused() {
      this.ap_transp_transport_mode_code_focus = true;
    },
    ap_transp_transport_mode_codeBlurred() {
      ap_transp_transport_mode_code_focus = false;
    },
    ap_transp_transport_nationality_code_Focused() {
      this.ap_transp_transport_nationality_code_focus = true;
    },
    ap_transp_transport_nationality_codeBlurred() {
      ap_transp_transport_nationality_code_focus = false;
    },
    ap_good_origin_country_name_Focused() {
      this.ap_good_origin_country_name_focus = true;
    },
    ap_good_origin_country_nameBlurred() {
      this.ap_good_origin_country_name_focus = false;
    },
    ap_send_rec_identity_card_code_Focused() {
      this.ap_send_rec_identity_card_code_focus = true;
    },
    ap_send_rec_identity_card_codeBlurred() {
      this.ap_send_rec_identity_card_code_focus = false;
    },
    country1_Focused() {
      this.country1_focus = true;
    },
    country1Blurred() {
      this.country1_focus = false;
    },
    country2_Focused() {
      this.country2_focus = true;
    },
    country2Blurred() {
      this.country2_focus = false;
    },
    country3_Focused() {
      this.country3_focus = true;
    },
    country3Blurred() {
      this.country3_focus = false;
    },
    country4_Focused() {
      this.country4_focus = true;
    },
    country4Blurred() {
      this.country4_focus = false;
    },
    country5_Focused() {
      this.country5_focus = true;
    },
    country5Blurred() {
      this.country5_focus = false;
    },
    country6_Focused() {
      this.country6_focus = true;
    },
    country6Blurred() {
      this.country6_focus = false;
    },

    ap_good_data_origin_country_code_Focused() {
      this.ap_good_data_origin_country_code_focus = true;
    },
    ap_good_data_origin_country_codeBlurred() {
      this.ap_good_data_origin_country_code_focus = false;
    },

    fm1_main_reason_Focused() {
      this.fm1_main_reason_focus = true;
    },
    fm1_main_reasonBlurred() {
      this.fm1_main_reason_focus = false;
    },
    fm1_main_form_state_Focused() {
      this.fm1_main_form_state_focus = true;
    },
    fm1_main_form_stateBlurred() {
      this.fm1_main_form_state_focus = false;
    },
    fm1_main_doc_kind_Focused() {
      this.fm1_main_doc_kind_focus = true;
    },
    fm1_main_doc_kindBlurred() {
      this.fm1_main_doc_kind_focus = false;
    },
    fm1_memb_subj_kind_Focused() {
      this.fm1_memb_subj_kind_focus = true;
    },
    fm1_memb_subj_kindBlurred() {
      this.fm1_memb_subj_kind_focus = false;
    },
    fm1_oper_currency_Focused() {
      this.fm1_oper_currency_focus = true;
    },
    fm1_oper_currencyBlurred() {
      this.fm1_oper_currency_focus = false;
    },
    fm1_memb_country_Focused() {
      this.fm1_memb_country_focus = true;
    },
    fm1_memb_countryBlurred() {
      this.fm1_memb_country_focus = false;
    },
    fm1_memb_org_form_Focused() {
      this.fm1_memb_org_form_focus = true;
    },
    fm1_memb_org_formBlurred() {
      this.fm1_memb_org_form_focus = false;
    },
    fm1_memb_founder_org_form_Focused() {
      this.fm1_memb_founder_org_form_focus = true;
    },
    fm1_memb_founder_org_formBlurred() {
      this.fm1_memb_founder_org_form_focus = false;
    },
    ap_main_transit_direction_code_Focused() {
      this.ap_main_transit_direction_code_focus = true;
    },
    ap_main_transit_direction_codeBlurred() {
      this.ap_main_transit_direction_code_focus = false;
    },

    fetchOkeds(search, loading) {
      this.getLibrary("oked", search, 10000);
    },
    okedsFocused() {
      this.oked_focused = true;
    },
    okedsBlurred() {
      this.oked_focused = false;
      this.validateField("company_oked");
    },

    currenciesFocused() {
      this.currency_focused = true;
    },
    currenciesBlurred() {
      this.currency_focused = false;
      // this.validateField('company_status')
    },
    buyerFocused() {
      this.buyer_focused = true;
    },
    buyerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    sellerFocused() {
      this.buyer_focused = true;
    },
    sellerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    buyer2Focused() {
      this.buyer_focused = true;
    },
    buyer2Blurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    seller2Focused() {
      this.buyer_focused = true;
    },
    seller2Blurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    tnvedFocused() {
      this.tnved_focused = true;
    },
    tnvedBlurred() {
      this.tnved_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    measureFocus() {
      this.measure_focused = true;
    },
    measureBlur() {
      this.measure_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    countryFocus() {
      this.country_focused = true;
    },
    countryBlur() {
      this.country_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    fetchDeliveryTerms(search, loading) {
      this.getLibrary("delivery_term", search, 10000);
    },
    deliveryFocused() {
      this.delivery_focused = true;
    },
    deliveryBlurred() {
      this.delivery_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    load() {
      axios
        .get(window.base + "/Document/LoadEPI/?id=" + this.document_id)
        .then((response) => {
          this.$emit("file", response.data.files);
          // axios
          //   .get(
          //     window.base +
          //       "/document?attis_contract_id=" +
          //       this.$route.params.id,
          //   )
          //   .then((response) => {
          //     response.data.forEach((item) => {
          //       if (item.DocType !== "ЭПИ") {
          //         let tmp_doc = {
          //           ap_prev_doc_preceding_document_date:
          //             item.DocumentDate != "undefined" ? item.DocumentDate : "",
          //           ap_prev_doc_preceding_document_number:
          //             item.DocumentNumber != "undefined"
          //               ? item.DocumentNumber
          //               : "",
          //           ap_prev_doc_preceding_document_name:
          //             item.DocType != "undefined" ? item.DocType : "",
          //           ap_prev_doc_kind:
          //             item.DocKind != "undefined" ? item.DocKind : "",
          //         };
          //         this.ap_prev_docs.push(tmp_doc);
          //       }
          //     });
          //   });
          axios
            .get(
              window.base +
                "/library?type=country&query=&qty=100000" +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((rs) => {
              this.countries = rs.data;
              this.ap_members1.ap_memb_organization_name =
                response.data.ap_memb_organization_name_1.trim() != "undefined"
                  ? response.data.ap_memb_organization_name_1.trim()
                  : "";
              this.ap_members1.ap_memb_short_name =
                response.data.ap_memb_short_name_1.trim() != "undefined"
                  ? response.data.ap_memb_short_name_1.trim()
                  : "";
              this.ap_members1.ap_memb_bin =
                response.data.ap_memb_bin_1.trim() != "undefined"
                  ? response.data.ap_memb_bin_1.trim()
                  : "";
              this.ap_members1.ap_memb_itn =
                response.data.ap_memb_itn_1.trim() != "undefined"
                  ? response.data.ap_memb_itn_1.trim()
                  : "";
              this.ap_members1.ap_member_postal_code =
                response.data.ap_member_postal_code_1.trim() != "undefined"
                  ? response.data.ap_member_postal_code_1.trim()
                  : "";

              this.ap_members1.ap_member_country_name =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_member_country_name_1.trim(),
                  )
                ];
              if (this.ap_members1.ap_member_country_name == "undefined")
                this.ap_members1.ap_member_country_name = { value: "" };
              this.ap_members1.ap_member_region =
                response.data.ap_member_region_1.trim() != "undefined"
                  ? response.data.ap_member_region_1.trim()
                  : "";
              this.ap_members1.ap_member_city =
                response.data.ap_member_city_1.trim() != "undefined"
                  ? response.data.ap_member_city_1.trim()
                  : "";
              this.ap_members1.ap_member_street_house =
                response.data.ap_member_street_house_1.trim() != "undefined"
                  ? response.data.ap_member_street_house_1.trim()
                  : "";

              this.ap_members2.ap_memb_organization_name =
                response.data.ap_memb_organization_name_2.trim() != "undefined"
                  ? response.data.ap_memb_organization_name_2.trim()
                  : "";
              this.ap_members2.ap_memb_short_name =
                response.data.ap_memb_short_name_2.trim() != "undefined"
                  ? response.data.ap_memb_short_name_2.trim()
                  : "";
              this.ap_members2.ap_memb_bin =
                response.data.ap_memb_bin_2.trim() != "undefined"
                  ? response.data.ap_memb_bin_2.trim()
                  : "";
              this.ap_members2.ap_memb_itn =
                response.data.ap_memb_itn_2.trim() != "undefined"
                  ? response.data.ap_memb_itn_2.trim()
                  : "";
              this.ap_members2.ap_member_postal_code =
                response.data.ap_member_postal_code_2.trim() != "undefined"
                  ? response.data.ap_member_postal_code_2.trim()
                  : "";

              this.ap_members2.ap_member_country_name =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_member_country_name_2.trim(),
                  )
                ];
              this.ap_members2.ap_member_region =
                response.data.ap_member_region_2.trim() != "undefined"
                  ? response.data.ap_member_region_2.trim()
                  : "";
              this.ap_members2.ap_member_city =
                response.data.ap_member_city_2.trim() != "undefined"
                  ? response.data.ap_member_city_2.trim()
                  : "";
              this.ap_members2.ap_member_street_house =
                response.data.ap_member_street_house_2.trim() != "undefined"
                  ? response.data.ap_member_street_house_2.trim()
                  : "";

              this.ap_members3.ap_memb_organization_name =
                response.data.ap_memb_organization_name_3.trim() != "undefined"
                  ? response.data.ap_memb_organization_name_3.trim()
                  : "";
              this.ap_members3.ap_memb_short_name =
                response.data.ap_memb_short_name_3.trim() != "undefined"
                  ? response.data.ap_memb_short_name_3.trim()
                  : "";
              this.ap_members3.ap_memb_bin =
                response.data.ap_memb_bin_3.trim() != "undefined"
                  ? response.data.ap_memb_bin_3.trim()
                  : "";
              this.ap_members3.ap_memb_itn =
                response.data.ap_memb_itn_3.trim() != "undefined"
                  ? response.data.ap_memb_itn_3.trim()
                  : "";
              this.ap_members3.ap_member_postal_code =
                response.data.ap_member_postal_code_3.trim() != "undefined"
                  ? response.data.ap_member_postal_code_3.trim()
                  : "";
              this.ap_members3.ap_member_country_name =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_member_country_name_3.trim(),
                  )
                ];
              this.ap_members3.ap_member_region =
                response.data.ap_member_region_3.trim() != "undefined"
                  ? response.data.ap_member_region_3.trim()
                  : "";
              this.ap_members3.ap_member_city =
                response.data.ap_member_city_3.trim() != "undefined"
                  ? response.data.ap_member_city_3.trim()
                  : "";
              this.ap_members3.ap_member_street_house =
                response.data.ap_member_street_house_3.trim() != "undefined"
                  ? response.data.ap_member_street_house_3.trim()
                  : "";

              this.ap_members4.ap_memb_organization_name =
                response.data.ap_memb_organization_name_4.trim() != "undefined"
                  ? response.data.ap_memb_organization_name_4.trim()
                  : "";
              this.ap_members4.ap_memb_short_name =
                response.data.ap_memb_short_name_4.trim() != "undefined"
                  ? response.data.ap_memb_short_name_4.trim()
                  : "";
              this.ap_members4.ap_memb_bin =
                response.data.ap_memb_bin_4.trim() != "undefined"
                  ? response.data.ap_memb_bin_4.trim()
                  : "";
              this.ap_members4.ap_memb_itn =
                response.data.ap_memb_itn_4.trim() != "undefined"
                  ? response.data.ap_memb_itn_4.trim()
                  : "";
              this.ap_members4.ap_member_postal_code =
                response.data.ap_member_postal_code_4.trim() != "undefined"
                  ? response.data.ap_member_postal_code_4.trim()
                  : "";
              this.ap_members4.ap_member_country_name =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_member_country_name_4.trim(),
                  )
                ];
              this.ap_members4.ap_member_region =
                response.data.ap_member_region_4.trim() != "undefined"
                  ? response.data.ap_member_region_4.trim()
                  : "";
              this.ap_members4.ap_member_city =
                response.data.ap_member_city_4.trim() != "undefined"
                  ? response.data.ap_member_city_4.trim()
                  : "";
              this.ap_members4.ap_member_street_house =
                response.data.ap_member_street_house_4.trim() != "undefined"
                  ? response.data.ap_member_street_house_4.trim()
                  : "";

              this.ap_members5.ap_memb_organization_name =
                response.data.ap_memb_organization_name_5.trim() != "undefined"
                  ? response.data.ap_memb_organization_name_5.trim()
                  : "";
              this.ap_members5.ap_memb_short_name =
                response.data.ap_memb_short_name_5.trim() != "undefined"
                  ? response.data.ap_memb_short_name_5.trim()
                  : "";
              this.ap_members5.ap_memb_bin =
                response.data.ap_memb_bin_5.trim() != "undefined"
                  ? response.data.ap_memb_bin_5.trim()
                  : "";
              this.ap_members5.ap_memb_itn =
                response.data.ap_memb_itn_5.trim() != "undefined"
                  ? response.data.ap_memb_itn_5.trim()
                  : "";
              this.ap_members5.ap_member_postal_code =
                response.data.ap_member_postal_code_5.trim() != "undefined"
                  ? response.data.ap_member_postal_code_5.trim()
                  : "";
              this.ap_members5.ap_member_country_name =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_member_country_name_5.trim(),
                  )
                ];
              this.ap_members5.ap_member_region =
                response.data.ap_member_region_5.trim() != "undefined"
                  ? response.data.ap_member_region_5.trim()
                  : "";
              this.ap_members5.ap_member_city =
                response.data.ap_member_city_5.trim() != "undefined"
                  ? response.data.ap_member_city_5.trim()
                  : "";
              this.ap_members5.ap_member_street_house =
                response.data.ap_member_street_house_5.trim() != "undefined"
                  ? response.data.ap_member_street_house_5.trim()
                  : "";

              this.ap_persons.ap_person_person_surname =
                response.data.ap_person_person_surname_1.trim() != "undefined"
                  ? response.data.ap_person_person_surname_1.trim()
                  : "";
              this.ap_persons.ap_person_person_name =
                response.data.ap_person_person_name_1.trim() != "undefined"
                  ? response.data.ap_person_person_name_1.trim()
                  : "";
              this.ap_persons.ap_person_person_middle_name =
                response.data.ap_person_person_middle_name_1.trim() !=
                "undefined"
                  ? response.data.ap_person_person_middle_name_1.trim()
                  : "";
              this.ap_persons.ap_person_person_post =
                response.data.ap_person_person_post_1.trim() != "undefined"
                  ? response.data.ap_person_person_post_1.trim()
                  : "";
              this.ap_persons.ap_person_contact_phone =
                response.data.ap_person_contact_phone_1.trim() != "undefined"
                  ? response.data.ap_person_contact_phone_1.trim()
                  : "";

              this.ap_persons2.ap_person_person_surname =
                response.data.ap_person_person_surname_2.trim() != "undefined"
                  ? response.data.ap_person_person_surname_2.trim()
                  : "";
              this.ap_persons2.ap_person_person_name =
                response.data.ap_person_person_name_2.trim() != "undefined"
                  ? response.data.ap_person_person_name_2.trim()
                  : "";
              this.ap_persons2.ap_person_person_middle_name =
                response.data.ap_person_person_middle_name_2.trim() !=
                "undefined"
                  ? response.data.ap_person_person_middle_name_2.trim()
                  : "";
              this.ap_persons2.ap_person_person_post =
                response.data.ap_person_person_post_2.trim() != "undefined"
                  ? response.data.ap_person_person_post_2.trim()
                  : "";
              this.ap_persons2.ap_person_reg_country_code =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_person_reg_country_code_2.trim(),
                  )
                ];
              this.ap_send_rec.ap_send_rec_identity_card_code =
                response.data.ap_send_rec_identity_card_code.trim() !=
                "undefined"
                  ? this.ap_send_rec_identity_card_codes[
                      this.ap_send_rec_identity_card_codes.findIndex(
                        (i) =>
                          i.value ==
                          response.data.ap_send_rec_identity_card_code.trim(),
                      )
                    ]
                  : { value: "", display_text: "" };
              this.ap_send_rec.ap_send_rec_identity_card_series =
                response.data.ap_send_rec_identity_card_series.trim() !=
                "undefined"
                  ? response.data.ap_send_rec_identity_card_series.trim()
                  : "";
              this.ap_send_rec.ap_send_rec_identity_card_number =
                response.data.ap_send_rec_identity_card_number.trim() !=
                "undefined"
                  ? response.data.ap_send_rec_identity_card_number.trim()
                  : "";
              this.ap_send_rec.ap_send_rec_identity_card_date =
                response.data.ap_send_rec_identity_card_date.trim() !=
                "undefined"
                  ? response.data.ap_send_rec_identity_card_date.trim()
                  : "";
              this.ap_send_rec.ap_send_rec_organization_name =
                response.data.ap_send_rec_organization_name.trim() !=
                "undefined"
                  ? response.data.ap_send_rec_organization_name.trim()
                  : "";

              this.ap_goods.ap_good_origin_country_name =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_good_origin_country_name.trim(),
                  )
                ];
              this.ap_goods.ap_good_specification_number =
                response.data.ap_good_specification_number.trim() != "undefined"
                  ? response.data.ap_good_specification_number.trim()
                  : "";
              this.ap_goods.ap_good_specification_list_number =
                response.data.ap_good_specification_list_number.trim() !=
                "undefined"
                  ? response.data.ap_good_specification_list_number.trim()
                  : "";
              this.ap_goods.ap_good_total_goods_number =
                response.data.ap_good_total_goods_number.trim().trim() !=
                "undefined"
                  ? response.data.ap_good_total_goods_number.trim().trim()
                  : "";
              this.ap_goods.ap_good_total_package_number =
                response.data.ap_good_total_package_number.trim() != "undefined"
                  ? response.data.ap_good_total_package_number.trim()
                  : "";
              this.ap_goods.ap_good_total_sheet_number =
                response.data.ap_good_total_sheet_number.trim() != "undefined"
                  ? response.data.ap_good_total_sheet_number.trim()
                  : "";
              this.ap_goods.ap_good_total_cust_cost =
                response.data.ap_good_total_cust_cost != "undefined"
                  ? response.data.ap_good_total_cust_cost
                  : "";
              this.ap_goods.ap_good_cust_cost_currency_code =
                this.currencies[
                  this.currencies.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_good_cust_cost_currency_code.trim(),
                  )
                ];

              this.ap_main.ap_main_reg_num =
                response.data.ap_main_reg_num.trim() != "undefined"
                  ? response.data.ap_main_reg_num.trim()
                  : "";

              this.ap_main.ap_main_decl_num =
                response.data.ap_main_decl_num.trim() != "undefined"
                  ? response.data.ap_main_decl_num.trim()
                  : "";
              this.ap_main.ap_main_decl_date =
                response.data.ap_main_decl_date.trim() != "undefined"
                  ? response.data.ap_main_decl_date.trim()
                  : "";
              if (typeof response.data.ap_main_carnet === "string")
                this.ap_main.ap_main_carnet =
                  response.data.ap_main_carnet.trim();
              else this.ap_main.ap_main_carnet = response.data.ap_main_carnet;

              this.ap_main.ap_main_country_code =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value == response.data.ap_main_country_code.trim(),
                  )
                ];
              this.ap_main.ap_main_reg_date =
                response.data.ap_main_reg_date.trim() != "undefined"
                  ? response.data.ap_main_reg_date.trim()
                  : "";
              // this.ap_main.ap_main_trans_kind_code = response.data.ap_main_trans_kind_code.trim()
              this.findLibValue(
                "usage_code",
                response.data.ap_main_trans_kind_code.trim(),
                "ap_main_trans_kind_code",
              );
              this.ap_main.ap_main_transit_direction_code =
                response.data.ap_main_transit_direction_code.trim() !=
                "undefined"
                  ? this.ap_main_transit_direction_codes[
                      this.ap_main_transit_direction_codes.findIndex(
                        (i) =>
                          i.value ==
                          response.data.ap_main_transit_direction_code.trim(),
                      )
                    ]
                  : { value: "", display_text: "" };
              this.ap_main.ap_main_electronic_document_sign =
                response.data.ap_main_electronic_document_sign.trim() !=
                "undefined"
                  ? response.data.ap_main_electronic_document_sign.trim()
                  : "";
              // this.ap_main.ap_main_declaration_kind =
              this.findLibValue(
                "declaration_kind",
                response.data.ap_main_declaration_kind.trim(),
                "ap_main_declaration_kind",
              );
              this.ap_main.ap_main_subsoil_sign =
                response.data.ap_main_subsoil_sign.trim() != "undefined"
                  ? response.data.ap_main_subsoil_sign.trim()
                  : "";
              this.ap_main.ap_main_seal_number =
                response.data.ap_main_seal_number.trim() != "undefined"
                  ? response.data.ap_main_seal_number.trim()
                  : "";
              this.ap_main.ap_main_seal_quantity =
                response.data.ap_main_seal_quantity.trim() != "undefined"
                  ? response.data.ap_main_seal_quantity.trim()
                  : "";
              this.ap_main.ap_main_language_cuesad =
                response.data.ap_main_language_cuesad.trim() != "undefined"
                  ? response.data.ap_main_language_cuesad.trim()
                  : "";
              this.findLibValue(
                "country",
                response.data.ap_main_recipient_country_code.trim(),
                "ap_main_recipient_country_code",
              );
              // this.ap_main.ap_main_recipient_country_code = this.countries[this.countries.findIndex(itm => itm.value==response.data.ap_main_recipient_country_code.trim())]
              // this.ap_main.ap_main_movement_code = response.data.ap_main_movement_code.trim()
              this.findLibValue(
                "goods_transfer_feature",
                response.data.ap_main_movement_code.trim(),
                "ap_main_movement_code",
              );

              this.ap_main.SignDate = response.data.SignDate;
              this.ap_main.SignatureType = response.data.SignatureType;
              this.ap_main.SignatureName = response.data.SignatureName;
              this.ap_main.IsSigned = response.data.IsSigned;
              this.ap_main.ap_astana_utin = response.data.ap_astana_utin;

              this.ap_transportations.ap_transp_information_type_code =
                this.ap_transp_information_type_codes[
                  this.ap_transp_information_type_codes.findIndex(
                    (i) =>
                      i.value ==
                      response.data.ap_transp_information_type_code.trim(),
                  )
                ];

              // this.ap_transportations.ap_transp_customs_office = this.customs_offices[this.customs_offices.findIndex(i=>i.value==response.data.ap_transp_customs_office.trim())]
              axios
                .get(
                  window.base +
                    "/library/customs_office?code=" +
                    response.data.ap_transp_customs_office +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((r) => {
                  this.ap_transportations.ap_transp_customs_office = r.data[0];
                });

              this.ap_transportations.ap_transp_customs_country_code =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_transp_customs_country_code.trim(),
                  )
                ];

              this.ap_transportations.ap_transp_container_indicator =
                response.data.ap_transp_container_indicator.trim() !=
                "undefined"
                  ? response.data.ap_transp_container_indicator.trim()
                  : "";

              this.ap_transportations.ap_transp_dispatch_country_code =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_transp_dispatch_country_code.trim(),
                  )
                ];

              this.ap_transportations.ap_transp_destination_country_code =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_transp_destination_country_code.trim(),
                  )
                ];

              // this.ap_transportations.ap_transp_customs_office_inout = this.customs_offices[this.customs_offices.findIndex(i=>i.value==response.data.ap_transp_customs_office_inout.trim())]
              axios
                .get(
                  window.base +
                    "/library/customs_office?code=" +
                    response.data.ap_transp_customs_office_inout +
                    "&lang=" +
                    this.$i18n.locale,
                )
                .then((r) => {
                  this.ap_transportations.ap_transp_customs_office_inout =
                    r.data[0];
                });

              this.ap_transportations.ap_transp_customs_country_code_io =
                this.countries[
                  this.countries.findIndex(
                    (itm) =>
                      itm.value ==
                      response.data.ap_transp_customs_country_code_io.trim(),
                  )
                ];

              this.ap_transportations.ap_transp_date_expected_arrival =
                response.data.ap_transp_date_expected_arrival.trim() !=
                "undefined"
                  ? response.data.ap_transp_date_expected_arrival.trim()
                  : "";

              this.ap_transportations.ap_transp_date_expected_arrival_time =
                response.data.ap_transp_date_expected_arrival_time.trim() !=
                "undefined"
                  ? response.data.ap_transp_date_expected_arrival_time.trim()
                  : "";

              this.ap_transportations.ap_transp_transport_mode_code =
                this.transport_mode_codes[
                  this.transport_mode_codes.findIndex(
                    (i) =>
                      i.value ==
                      response.data.ap_transp_transport_mode_code.trim(),
                  )
                ];

              this.ap_transportations.ap_transp_transport_nationality_code =
                this.countries[
                  this.countries.findIndex(
                    (i) =>
                      i.value ==
                      response.data.ap_transp_transport_nationality_code.trim(),
                  )
                ];

              this.ap_transportations.ap_transp_vin =
                response.data.ap_transp_vin.trim() != "undefined"
                  ? response.data.ap_transp_vin.trim()
                  : "";

              this.ap_transportations.ap_transp_transport_identifier =
                response.data.ap_transp_transport_identifier.trim() !=
                "undefined"
                  ? response.data.ap_transp_transport_identifier.trim()
                  : "";

              this.ap_transportations.ap_transp_active_transport_identifier =
                response.data.ap_transp_active_transport_identifier.trim() !=
                "undefined"
                  ? response.data.ap_transp_active_transport_identifier.trim()
                  : "";
            });

          response.data.prev_docs.forEach((item) => {
            let tmp_doc = {
              ap_prev_doc_preceding_document_date: item.ap_prev_doc_preceding_document_date != "undefined" ? item.ap_prev_doc_preceding_document_date : "",
              ap_prev_doc_preceding_document_number: item.ap_prev_doc_preceding_document_number != "undefined" ? item.ap_prev_doc_preceding_document_number : "",
              ap_prev_doc_preceding_document_name: item.ap_prev_doc_preceding_document_name != "undefined" ? item.ap_prev_doc_preceding_document_name : "",
              ap_prev_doc_kind: item.ap_prev_doc_kind != "undefined" ?             
                this.custdoc_kinds[this.custdoc_kinds.findIndex((custDocKind) =>
                  custDocKind.value == item.ap_prev_doc_kind.trim(),
                )] : { value: "" },
            };
            this.ap_prev_docs.push(tmp_doc);
          });

          response.data.product.forEach((item, index) => {
            var tmp = {};
            tmp.good_no = item.good_no;
            tmp.good_guid = item.good_guid;
            tmp.ap_good_data_goods_numeric =
              item.ap_good_data_goods_numeric.trim();
            tmp.ap_good_data_list_numeric =
              item.ap_good_data_list_numeric.trim();
            tmp.ap_good_data_goods_description =
              item.ap_good_data_goods_description;
            tmp.ap_good_data_quant = item.ap_good_data_quant;
            tmp.ap_good_data_container_num = item.ap_good_data_container_num;
            tmp.ap_good_data_gross_weight_quantity =
              item.ap_good_data_gross_weight_quantity;
            tmp.ap_good_data_net_weight_quantity =
              item.ap_good_data_net_weight_quantity;
            tmp.ap_good_data_invoiced_cost = item.ap_good_data_invoiced_cost;
            tmp.ap_good_data_customs_cost = item.ap_good_data_customs_cost;
            tmp.ap_good_data_statistical_cost =
              item.ap_good_data_statistical_cost;
            if (typeof item.ap_good_data_places !== "undefined")
              tmp.ap_good_data_places = item.ap_good_data_places;
            if (typeof item.ap_good_data_packet !== "undefined")
              tmp.ap_good_data_packet =
                this.ap_good_data_packets[
                  this.ap_good_data_packets.findIndex(
                    (i) => i.value == item.ap_good_data_packet,
                  )
                ];
            if (typeof item.ap_good_data_places_name !== "undefined")
              tmp.ap_good_data_places_name = item.ap_good_data_places_name;

            this.ap_good_data.push(tmp);

            this.findLibValueProduct(
              "tnved",
              item.ap_good_data_goods_tnved_code.trim(),
              "ap_good_data_goods_tnved_code",
              index,
            );
            this.findLibValueProduct(
              "country",
              item.ap_good_data_origin_country_code.trim(),
              "ap_good_data_origin_country_code",
              index,
            );
            this.findLibValueProduct(
              "delivery_term",
              item.ap_good_data_delivery_terms_string_code.trim(),
              "ap_good_data_delivery_terms_string_code",
              index,
            );
            this.findLibValueProduct(
              "measure",
              item.ap_good_data_ext_measure.trim(),
              "ap_good_data_ext_measure",
              index,
            );
          });
          // this.CMR.cmr_number = response.data.cmr_number
          // this.CMR.cmr_date = response.data.cmr_date
          // this.CMR.cmr_sender = response.data.cmr_sender
          // this.CMR.cmr_recipient = response.data.cmr_recipient
          // this.CMR.cmr_courier = response.data.cmr_courier
          // this.CMR.cmr_courier_next = response.data.cmr_courier_next
          // this.CMR.cmr_track = response.data.cmr_track
          // this.CMR.cmr_trailer = response.data.cmr_trailer

          // this.ContractDeliveryTerms.DeliveryPlace=response.data.DeliveryPlace
          // this.ContractDeliveryTerms.DeliveryTermsStringCode=response.data.DeliveryTermsStringCode
          // this.ContractDeliveryTerms.TermsDescription=response.data.TermsDescription

          // this.TakingCargoPlace.CountryCode=response.data.CountryCode
          // this.TakingCargoPlace.City=response.data.City
          // this.TakingCargoPlace.StreetHouse=response.data.StreetHouse
          // this.TakingCargoPlace.PostalCode=response.data.PostalCode
          // this.ap_main.ap_main_decl_date=response.data.TakingCargoDate

          // this.EnclosedDocument.PrDocumentName=response.data.PrDocumentName
          // this.EnclosedDocument.PrDocumentNumber=response.data.PrDocumentNumber
          // this.EnclosedDocument.PrDocumentDate=response.data.PrDocumentDate

          // this.ConsigneeCustoms.WarehouseName=response.data.WarehouseName

          // response.data.CMRGoods.forEach((good, index)=>{
          // 	var tmp_good = {
          // 		GoodMarking: good.GoodMarking,
          // 		GoodsDescription: good.GoodsDescription,
          // 		GoodsQuantity: good.GoodsQuantity,
          // 		GrossWeightQuantity: good.GrossWeightQuantity,
          // 		GoodsNomenclatureCode: good.GoodsNomenclatureCode,
          // 		VolumeQuantity: good.VolumeQuantity,
          // 	}
          // 	this.CMRGoods.push(tmp_good)
          // 	// this.findLibValueProduct('tnved', good.GoodsCode, 'GoodsCode', index)
          // 	// this.findLibValueProduct('country', good.OriginCountryCode, 'OriginCountryCode', index)
          // 	// this.findLibValueProduct('measure', good.SupplementaryQualifierName, 'SupplementaryQualifierName', index)

          // })
        });
    },
    stringifyProducts() {
      var result = [];
      this.CMRGoods.forEach((product, index) => {
        var line = "";

        line = "product[" + index + "].GoodMarking=" + product.GoodMarking;
        line += "&product[" + index + "].good_no=" + product.good_no;
        line += "&product[" + index + "].good_guid=" + product.good_guid;
        line +=
          "&product[" +
          index +
          "].GoodsDescription=" +
          product.GoodsDescription;
        line +=
          "&product[" + index + "].GoodsQuantity=" + product.GoodsQuantity;
        line +=
          "&product[" +
          index +
          "].GrossWeightQuantity=" +
          product.GrossWeightQuantity;
        line +=
          "&product[" +
          index +
          "].GoodsNomenclatureCode=" +
          product.GoodsNomenclatureCode;
        line +=
          "&product[" + index + "].VolumeQuantity=" + product.VolumeQuantity;

        // if(typeof product.GoodsCode !=='undefined')
        // 	line += '&product['+index+'].GoodsCode='+product.GoodsCode.value
        // if(typeof product.OriginCountryCode !=='undefined')
        // 	line += '&product['+index+'].OriginCountryCode='+product.OriginCountryCode.value
        // if(typeof product.SupplementaryQualifierName !=='undefined')
        // 	line += '&product['+index+'].SupplementaryQualifierName='+product.SupplementaryQualifierName.value

        result.push(line);
      });
      return result.join("&");
    },
    compileErrors() {
      const h = this.$createElement;
      let text = [];
      text.push(
        h("div", { domProps: { innerHTML: this.$t("message.errors-dialog") } }),
      );
      if (this.$v.ap_main.$anyError) {
        text.push(
          h("div", {
            domProps: {
              innerHTML:
                this.$t("message.errors-at-tab") +
                this.$t("message.contracts.document_epi_tab_1_short"),
            },
          }),
        );
      }
      if (this.$v.ap_goods.$anyError) {
        text.push(
          h("div", {
            domProps: {
              innerHTML:
                this.$t("message.errors-at-tab") +
                this.$t("message.contracts.document_epi_tab_2_short"),
            },
          }),
        );
      }
      if (this.$v.ap_persons.$anyError) {
        text.push(
          h("div", {
            domProps: {
              innerHTML:
                this.$t("message.errors-at-tab") +
                this.$t("message.contracts.document_epi_tab_3_short"),
            },
          }),
        );
      }

      return h("div", {}, text);
    },
    saveDocument(validate) {
      // console.log(data)
      this.$v.$touch();
      if (this.$v.$error === true) {
        this.form_error = true;
        // setTimeout(()=>{
        // 	$('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
        // }, 100)
        this.$bvModal.msgBoxOk(this.compileErrors(), {
          title: this.$t("message.errors-dialog-title"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.ok"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        });
      } else {
        this.$root.$emit("show-loading");
        this.buttons_loading = true;
        var formData = new FormData();
        formData.append("document_category", "customs");
        formData.append("file", this.document.file);
        formData.append(
          "ap_memb_organization_name_1",
          this.check_undefined(this.ap_members1.ap_memb_organization_name),
        );
        formData.append(
          "ap_memb_short_name_1",
          this.check_undefined(this.ap_members1.ap_memb_short_name),
        );
        formData.append(
          "ap_memb_bin_1",
          this.check_undefined(this.ap_members1.ap_memb_bin),
        );
        formData.append(
          "ap_memb_itn_1",
          this.check_undefined(this.ap_members1.ap_memb_itn),
        );
        formData.append(
          "ap_member_postal_code_1",
          this.check_undefined(this.ap_members1.ap_member_postal_code),
        );
        if (
          typeof this.ap_members1.ap_member_country_name !== "undefined" &&
          typeof this.ap_members1.ap_member_country_name.value !== "undefined"
        )
          formData.append(
            "ap_member_country_name_1",
            this.ap_members1.ap_member_country_name.value,
          );
        formData.append(
          "ap_member_region_1",
          this.check_undefined(this.ap_members1.ap_member_region),
        );
        formData.append(
          "ap_member_city_1",
          this.check_undefined(this.ap_members1.ap_member_city),
        );
        formData.append(
          "ap_member_street_house_1",
          this.check_undefined(this.ap_members1.ap_member_street_house),
        );

        formData.append(
          "ap_memb_organization_name_2",
          this.check_undefined(this.ap_members2.ap_memb_organization_name),
        );
        formData.append(
          "ap_memb_short_name_2",
          this.check_undefined(this.ap_members2.ap_memb_short_name),
        );
        formData.append(
          "ap_memb_bin_2",
          this.check_undefined(this.ap_members2.ap_memb_bin),
        );
        formData.append(
          "ap_memb_itn_2",
          this.check_undefined(this.ap_members2.ap_memb_itn),
        );
        formData.append(
          "ap_member_postal_code_2",
          this.check_undefined(this.ap_members2.ap_member_postal_code),
        );
        if (
          typeof this.ap_members2.ap_member_country_name !== "undefined" &&
          typeof this.ap_members2.ap_member_country_name.value !== "undefined"
        )
          formData.append(
            "ap_member_country_name_2",
            this.check_undefined(this.ap_members2.ap_member_country_name.value),
          );
        formData.append(
          "ap_member_region_2",
          this.check_undefined(this.ap_members2.ap_member_region),
        );
        formData.append(
          "ap_member_city_2",
          this.check_undefined(this.ap_members2.ap_member_city),
        );
        formData.append(
          "ap_member_street_house_2",
          this.check_undefined(this.ap_members2.ap_member_street_house),
        );

        formData.append(
          "ap_memb_organization_name_3",
          this.check_undefined(this.ap_members3.ap_memb_organization_name),
        );
        formData.append(
          "ap_memb_short_name_3",
          this.check_undefined(this.ap_members3.ap_memb_short_name),
        );
        formData.append(
          "ap_memb_bin_3",
          this.check_undefined(this.ap_members3.ap_memb_bin),
        );
        formData.append(
          "ap_memb_itn_3",
          this.check_undefined(this.ap_members3.ap_memb_itn),
        );
        formData.append(
          "ap_member_postal_code_3",
          this.check_undefined(this.ap_members3.ap_member_postal_code),
        );
        if (
          typeof this.ap_members3.ap_member_country_name !== "undefined" &&
          typeof this.ap_members3.ap_member_country_name.value !== "undefined"
        )
          formData.append(
            "ap_member_country_name_3",
            this.ap_members3.ap_member_country_name.value,
          );
        formData.append(
          "ap_member_region_3",
          this.check_undefined(this.ap_members3.ap_member_region),
        );
        formData.append(
          "ap_member_city_3",
          this.check_undefined(this.ap_members3.ap_member_city),
        );
        formData.append(
          "ap_member_street_house_3",
          this.check_undefined(this.ap_members3.ap_member_street_house),
        );

        formData.append(
          "ap_memb_organization_name_4",
          this.check_undefined(this.ap_members4.ap_memb_organization_name),
        );
        formData.append(
          "ap_memb_short_name_4",
          this.check_undefined(this.ap_members4.ap_memb_short_name),
        );
        formData.append(
          "ap_memb_bin_4",
          this.check_undefined(this.ap_members4.ap_memb_bin),
        );
        formData.append(
          "ap_memb_itn_4",
          this.check_undefined(this.ap_members4.ap_memb_itn),
        );
        formData.append(
          "ap_member_postal_code_4",
          this.check_undefined(this.ap_members4.ap_member_postal_code),
        );
        if (
          typeof this.ap_members4.ap_member_country_name !== "undefined" &&
          typeof this.ap_members4.ap_member_country_name.value !== "undefined"
        )
          formData.append(
            "ap_member_country_name_4",
            this.ap_members4.ap_member_country_name.value,
          );
        formData.append(
          "ap_member_region_4",
          this.check_undefined(this.ap_members4.ap_member_region),
        );
        formData.append(
          "ap_member_city_4",
          this.check_undefined(this.ap_members4.ap_member_city),
        );
        formData.append(
          "ap_member_street_house_4",
          this.check_undefined(this.ap_members4.ap_member_street_house),
        );

        formData.append(
          "ap_memb_organization_name_5",
          this.check_undefined(this.ap_members5.ap_memb_organization_name),
        );
        formData.append(
          "ap_memb_short_name_5",
          this.check_undefined(this.ap_members5.ap_memb_short_name),
        );
        formData.append(
          "ap_memb_bin_5",
          this.check_undefined(this.ap_members5.ap_memb_bin),
        );
        formData.append(
          "ap_memb_itn_5",
          this.check_undefined(this.ap_members5.ap_memb_itn),
        );
        formData.append(
          "ap_member_postal_code_5",
          this.check_undefined(this.ap_members5.ap_member_postal_code),
        );
        if (
          typeof this.ap_members5.ap_member_country_name !== "undefined" &&
          typeof this.ap_members5.ap_member_country_name.value !== "undefined"
        )
          formData.append(
            "ap_member_country_name_5",
            this.ap_members5.ap_member_country_name.value,
          );
        formData.append(
          "ap_member_region_5",
          this.check_undefined(this.ap_members5.ap_member_region),
        );
        formData.append(
          "ap_member_city_5",
          this.check_undefined(this.ap_members5.ap_member_city),
        );
        formData.append(
          "ap_member_street_house_5",
          this.check_undefined(this.ap_members5.ap_member_street_house),
        );

        formData.append(
          "ap_person_person_surname_1",
          this.check_undefined(this.ap_persons.ap_person_person_surname),
        );
        formData.append(
          "ap_person_person_name_1",
          this.check_undefined(this.ap_persons.ap_person_person_name),
        );
        formData.append(
          "ap_person_person_middle_name_1",
          this.check_undefined(this.ap_persons.ap_person_person_middle_name),
        );
        formData.append(
          "ap_person_person_post_1",
          this.check_undefined(this.ap_persons.ap_person_person_post),
        );
        formData.append(
          "ap_person_contact_phone_1",
          this.check_undefined(this.ap_persons.ap_person_contact_phone),
        );

        formData.append(
          "ap_person_person_surname_2",
          this.check_undefined(this.ap_persons2.ap_person_person_surname),
        );
        formData.append(
          "ap_person_person_name_2",
          this.check_undefined(this.ap_persons2.ap_person_person_name),
        );
        formData.append(
          "ap_person_person_middle_name_2",
          this.check_undefined(this.ap_persons2.ap_person_person_middle_name),
        );
        formData.append(
          "ap_person_person_post_2",
          this.check_undefined(this.ap_persons2.ap_person_person_post),
        );
        if (
          typeof this.ap_persons2.ap_person_reg_country_code !== "undefined" &&
          typeof this.ap_persons2.ap_person_reg_country_code.value !==
            "undefined"
        )
          formData.append(
            "ap_person_reg_country_code_2",
            this.ap_persons2.ap_person_reg_country_code.value,
          );

        if (
          typeof this.ap_send_rec.ap_send_rec_identity_card_code !==
            "undefined" &&
          typeof this.ap_send_rec.ap_send_rec_identity_card_code.value !==
            "undefined"
        )
          formData.append(
            "ap_send_rec_identity_card_code",
            this.ap_send_rec.ap_send_rec_identity_card_code.value,
          );
        else formData.append("ap_send_rec_identity_card_code", "");
        formData.append(
          "ap_send_rec_identity_card_series",
          this.ap_send_rec.ap_send_rec_identity_card_series,
        );
        formData.append(
          "ap_send_rec_identity_card_number",
          this.ap_send_rec.ap_send_rec_identity_card_number,
        );
        formData.append(
          "ap_send_rec_identity_card_date",
          this.ap_send_rec.ap_send_rec_identity_card_date,
        );
        formData.append(
          "ap_send_rec_organization_name",
          this.ap_send_rec.ap_send_rec_organization_name,
        );

        if (
          typeof this.ap_goods.ap_good_origin_country_name !== "undefined" &&
          typeof this.ap_goods.ap_good_origin_country_name.value !== "undefined"
        )
          formData.append(
            "ap_good_origin_country_name",
            this.ap_goods.ap_good_origin_country_name.value,
          );
        formData.append(
          "ap_good_specification_number",
          this.ap_goods.ap_good_specification_number,
        );
        formData.append(
          "ap_good_specification_list_number",
          this.ap_goods.ap_good_specification_list_number,
        );
        formData.append(
          "ap_good_total_goods_number",
          this.ap_goods.ap_good_total_goods_number,
        );
        formData.append(
          "ap_good_total_package_number",
          this.ap_goods.ap_good_total_package_number,
        );
        formData.append(
          "ap_good_total_sheet_number",
          this.ap_goods.ap_good_total_sheet_number,
        );
        formData.append(
          "ap_good_total_cust_cost",
          this.ap_goods.ap_good_total_cust_cost,
        );
        if (
          typeof this.ap_goods.ap_good_cust_cost_currency_code !==
            "undefined" &&
          typeof this.ap_goods.ap_good_cust_cost_currency_code.value !==
            "undefined"
        )
          formData.append(
            "ap_good_cust_cost_currency_code",
            this.ap_goods.ap_good_cust_cost_currency_code.value,
          );

        formData.append("ap_main_reg_num", this.ap_main.ap_main_reg_num);
        if (
          typeof this.ap_main.ap_main_country_code !== "undefined" &&
          typeof this.ap_main.ap_main_country_code.value !== "undefined"
        )
          formData.append(
            "ap_main_country_code",
            this.ap_main.ap_main_country_code.value,
          );
        formData.append("ap_main_reg_date", this.ap_main.ap_main_reg_date);
        if (
          typeof this.ap_main.ap_main_trans_kind_code !== "undefined" &&
          typeof this.ap_main.ap_main_trans_kind_code.value !== "undefined"
        )
          formData.append(
            "ap_main_trans_kind_code",
            this.ap_main.ap_main_trans_kind_code.value,
          );
        if (
          typeof this.ap_main.ap_main_transit_direction_code !== "undefined" &&
          typeof this.ap_main.ap_main_transit_direction_code.value !==
            "undefined"
        )
        
        formData.append(
          "ap_main_transit_direction_code",
          this.ap_main.ap_main_transit_direction_code.value,
        );

        formData.append(
          "ap_main_electronic_document_sign",
          this.ap_main.ap_main_electronic_document_sign,
        );

        formData.append(
          "ap_main_carnet",
          this.ap_main.ap_main_carnet == true ? 1 : 0,
        );

        if (
          typeof this.ap_main.ap_main_declaration_kind !== "undefined" &&
          typeof this.ap_main.ap_main_declaration_kind.value !== "undefined"
        )
          formData.append(
            "ap_main_declaration_kind",
            this.ap_main.ap_main_declaration_kind.value,
          );
        formData.append(
          "ap_main_subsoil_sign",
          this.ap_main.ap_main_subsoil_sign,
        );
        formData.append(
          "ap_main_seal_number",
          this.ap_main.ap_main_seal_number,
        );
        formData.append(
          "ap_main_seal_quantity",
          this.ap_main.ap_main_seal_quantity,
        );
        formData.append("ap_main_decl_num", this.ap_main.ap_main_decl_num);
        formData.append("ap_main_decl_date", this.ap_main.ap_main_decl_date);
        // if(typeof this.ap_main.ap_main_language_cuesad!=='undefined' && typeof this.ap_main.ap_main_language_cuesad.value !== 'undefined')
        formData.append(
          "ap_main_language_cuesad",
          this.ap_main.ap_main_language_cuesad,
        );
        if (
          typeof this.ap_main.ap_main_recipient_country_code !== "undefined" &&
          typeof this.ap_main.ap_main_recipient_country_code.value !==
            "undefined"
        )
          formData.append(
            "ap_main_recipient_country_code",
            this.ap_main.ap_main_recipient_country_code.value,
          );
        if (
          typeof this.ap_main.ap_main_movement_code !== "undefined" &&
          typeof this.ap_main.ap_main_movement_code.value !== "undefined"
        )
          formData.append(
            "ap_main_movement_code",
            this.ap_main.ap_main_movement_code.value,
          );

        if (
          typeof this.ap_transportations.ap_transp_information_type_code !==
            "undefined" &&
          typeof this.ap_transportations.ap_transp_information_type_code
            .value !== "undefined"
        )
          formData.append(
            "ap_transp_information_type_code",
            this.ap_transportations.ap_transp_information_type_code.value,
          );
        if (
          typeof this.ap_transportations.ap_transp_customs_office !==
            "undefined" &&
          typeof this.ap_transportations.ap_transp_customs_office.value !==
            "undefined"
        )
          formData.append(
            "ap_transp_customs_office",
            this.ap_transportations.ap_transp_customs_office.value,
          );
        if (
          typeof this.ap_transportations.ap_transp_customs_country_code !==
            "undefined" &&
          typeof this.ap_transportations.ap_transp_customs_country_code
            .value !== "undefined"
        )
          formData.append(
            "ap_transp_customs_country_code",
            this.ap_transportations.ap_transp_customs_country_code.value,
          );
        formData.append(
          "ap_transp_container_indicator",
          this.ap_transportations.ap_transp_container_indicator,
        );
        formData.append(
          "ap_transp_date_expected_arrival_time",
          this.ap_transportations.ap_transp_date_expected_arrival_time,
        );
        if (
          typeof this.ap_transportations.ap_transp_dispatch_country_code !==
            "undefined" &&
          typeof this.ap_transportations.ap_transp_dispatch_country_code
            .value !== "undefined"
        )
          formData.append(
            "ap_transp_dispatch_country_code",
            this.ap_transportations.ap_transp_dispatch_country_code.value,
          );
        if (
          typeof this.ap_transportations.ap_transp_destination_country_code !==
            "undefined" &&
          typeof this.ap_transportations.ap_transp_destination_country_code
            .value !== "undefined"
        )
          formData.append(
            "ap_transp_destination_country_code",
            this.ap_transportations.ap_transp_destination_country_code.value,
          );
        if (
          typeof this.ap_transportations.ap_transp_customs_office_inout !==
            "undefined" &&
          typeof this.ap_transportations.ap_transp_customs_office_inout
            .value !== "undefined"
        )
          formData.append(
            "ap_transp_customs_office_inout",
            this.ap_transportations.ap_transp_customs_office_inout.value,
          );
        if (
          typeof this.ap_transportations.ap_transp_customs_country_code_io !==
            "undefined" &&
          typeof this.ap_transportations.ap_transp_customs_country_code_io
            .value !== "undefined"
        )
          formData.append(
            "ap_transp_customs_country_code_io",
            this.ap_transportations.ap_transp_customs_country_code_io.value,
          );
        formData.append(
          "ap_transp_date_expected_arrival",
          this.ap_transportations.ap_transp_date_expected_arrival,
        );
        if (
          typeof this.ap_transportations.ap_transp_transport_mode_code !==
            "undefined" &&
          typeof this.ap_transportations.ap_transp_transport_mode_code.value !==
            "undefined"
        )
          formData.append(
            "ap_transp_transport_mode_code",
            this.ap_transportations.ap_transp_transport_mode_code.value,
          );
        if (
          typeof this.ap_transportations
            .ap_transp_transport_nationality_code !== "undefined" &&
          typeof this.ap_transportations.ap_transp_transport_nationality_code
            .value !== "undefined"
        )
          formData.append(
            "ap_transp_transport_nationality_code",
            this.ap_transportations.ap_transp_transport_nationality_code.value,
          );
        formData.append("ap_transp_vin", this.ap_transportations.ap_transp_vin);
        formData.append(
          "ap_transp_transport_identifier",
          this.ap_transportations.ap_transp_transport_identifier,
        );
        formData.append(
          "ap_transp_active_transport_identifier",
          this.ap_transportations.ap_transp_active_transport_identifier,
        );

        this.ap_good_data.forEach((item, index) => {
          formData.append("product[" + index + "].good_guid", item.good_guid);
          formData.append(
            "product[" + index + "].ap_good_data_goods_numeric",
            item.ap_good_data_goods_numeric,
          );
          formData.append(
            "product[" + index + "].ap_good_data_list_numeric",
            item.ap_good_data_list_numeric,
          );
          formData.append(
            "product[" + index + "].ap_good_data_goods_description",
            item.ap_good_data_goods_description,
          );
          if (item.ap_good_data_quant == "") item.ap_good_data_quant = 0;
          formData.append(
            "product[" + index + "].ap_good_data_quant",
            item.ap_good_data_quant,
          );
          formData.append(
            "product[" + index + "].ap_good_data_container_num",
            item.ap_good_data_container_num,
          );

          formData.append(
            "product[" + index + "].ap_good_data_gross_weight_quantity",
            item.ap_good_data_gross_weight_quantity,
          );
          formData.append(
            "product[" + index + "].ap_good_data_net_weight_quantity",
            item.ap_good_data_net_weight_quantity,
          );
          formData.append(
            "product[" + index + "].ap_good_data_invoiced_cost",
            item.ap_good_data_invoiced_cost,
          );
          formData.append(
            "product[" + index + "].ap_good_data_customs_cost",
            item.ap_good_data_customs_cost,
          );
          formData.append(
            "product[" + index + "].ap_good_data_statistical_cost",
            item.ap_good_data_statistical_cost,
          );

          formData.append(
            "product[" + index + "].ap_good_data_places",
            item.ap_good_data_places,
          );
          formData.append(
            "product[" + index + "].ap_good_data_places_name",
            item.ap_good_data_places_name,
          );

          if (
            typeof item.ap_good_data_packet !== "undefined" &&
            typeof item.ap_good_data_packet.value !== "undefined"
          )
            formData.append(
              "product[" + index + "].ap_good_data_packet",
              item.ap_good_data_packet.value,
            );
          if (
            typeof item.ap_good_data_goods_tnved_code !== "undefined" &&
            typeof item.ap_good_data_goods_tnved_code.value !== "undefined"
          )
            formData.append(
              "product[" + index + "].ap_good_data_goods_tnved_code",
              item.ap_good_data_goods_tnved_code.value,
            );
          if (
            typeof item.ap_good_data_ext_measure !== "undefined" &&
            typeof item.ap_good_data_ext_measure.value !== "undefined"
          )
            formData.append(
              "product[" + index + "].ap_good_data_ext_measure",
              item.ap_good_data_ext_measure.value,
            );

          if (
            typeof item.ap_good_data_origin_country_code !== "undefined" &&
            typeof item.ap_good_data_origin_country_code.value !== "undefined"
          )
            formData.append(
              "product[" + index + "].ap_good_data_origin_country_code",
              item.ap_good_data_origin_country_code.value,
            );
          if (
            typeof item.ap_good_data_delivery_terms_string_code !==
              "undefined" &&
            typeof item.ap_good_data_delivery_terms_string_code.value !==
              "undefined"
          )
            formData.append(
              "product[" + index + "].ap_good_data_delivery_terms_string_code",
              item.ap_good_data_delivery_terms_string_code.value,
            );
        });
        this.ap_prev_docs.forEach((item, index)=>{
        	formData.append("prev_docs[" + index + "].ap_prev_doc_preceding_document_date", item.ap_prev_doc_preceding_document_date)
        	formData.append("prev_docs[" + index + "].ap_prev_doc_preceding_document_number", item.ap_prev_doc_preceding_document_number)
        	formData.append("prev_docs[" + index + "].ap_prev_doc_preceding_document_name", item.ap_prev_doc_preceding_document_name)
        	formData.append("prev_docs[" + index + "].ap_prev_doc_kind", item.ap_prev_doc_kind.value)
        })
        var t1 = this.$t("message.error");
        axios
          .post(
            window.base +
              (this.is_new
                ? "/Document/CreateEPI" +
                  "?attis_contract_id=" +
                  this.$route.params.id
                : "/Document/UpdateEPI" +
                  "?attis_contract_id=" +
                  this.document_id),
            /*querystring.stringify(tmp)+'&'+this.stringifyProducts()+querystring.stringify(data.document)+'&document_id='+this.document_id+'&document_category=finance', */ formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          )
          .then((response) => {
            this.buttons_loading = false;
            if (response.data.status == "ok") {
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.epi-created"),
                timeout: 5000,
              }).show();
              if (validate && response.data.doc_id !== null) {
                //this.document_id = response.data.doc_id;
                this.$root.$emit("unshow-loading");
                this.buttons_loading = false;
                setTimeout(() => {
                  this.$root.$emit("save-and-validate", response.data.doc_id);
                  this.current_tab = 0;
                  setTimeout(() => {
                    //var element = document.querySelector('#ap_main_reg_date')
                    //var element_pos = this.findPos(element)
                    //element.parentNode.classList.add('error')
                    //element.focus()
                    if (document.querySelector("#modal-document") != null)
                      document.querySelector("#modal-document").scrollTo(0, 0);
                    if (document.querySelector("#modal-document-new") != null)
                      document
                        .querySelector("#modal-document-new")
                        .scrollTo(0, 0);
                  }, 500);
                }, 500);
              } else {
                this.$root.$emit("loadDocuments", { category: "all" });
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            } else {
              new Noty({
                theme: "light",
                type: "error",
                text:
                  this.$root.$t("message.message.epi-not-created") +
                  " (" +
                  response.data +
                  ")",
                timeout: 5000,
              }).show();
              if (window.dev_mode) {
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            }
          })
          .catch((e) => {
            new Noty({
              theme: "light",
              type: "error",
              text: t1,
              timeout: 5000,
            }).show();
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
          });
        // console.log(tmp, data.document, this.stringifyProducts())
        // axios.post(window.base+(this.document_id=='new'?'/Document/Create':'/Document/Update')+'?attis_contract_id='+this.$route.params.id, querystring.stringify(tmp)+'&'+this.stringifyProducts()+querystring.stringify(data.document)+'&document_id='+this.document_id+'&document_category=finance')
      }
    },
    show_lo_label(l) {
      // console.log(l)
      setTimeout(() => {
        document.querySelector('[for="' + l + '"]').classList.add("lo");
      }, 100);
    },
    hide_lo_label(l) {
      setTimeout(() => {
        document.querySelector('[for="' + l + '"]').classList.remove("lo");
      }, 100);
    },
    check_undefined(field) {
      if (typeof field !== "undefined")
        return field.trim() != "undefined" ? field.trim() : "";
      return "";
    },
    importGoodsExcel(event, index) {
      if (typeof event.target.files[0] !== "undefined") {
        var fd = new FormData();
        this.files_loading = true;
        fd.append("Files[0]", event.target.files[0]);
        axios
          .post(window.base + "/document/import_excel_goods?type=epi", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.files_loading = false;
            if (response.data !== "error") {
              response.data.forEach((good) => {
                var tmp = {};
                tmp.ap_good_data_list_numeric = this.ap_good_data.length + 1;
                tmp.ap_good_data_goods_numeric = this.ap_good_data.length + 1;
                tmp.good_guid = this.ap_good_data.length + 1;
                tmp.ap_good_data_list_numeric = good.ap_good_data_list_numeric;
                tmp.ap_good_data_goods_description =
                  good.ap_good_data_goods_description;
                tmp.ap_good_data_quant = good.ap_good_data_quant;
                tmp.ap_good_data_container_num =
                  good.ap_good_data_container_num;
                tmp.ap_good_data_gross_weight_quantity =
                  good.ap_good_data_gross_weight_quantity;
                tmp.ap_good_data_net_weight_quantity =
                  good.ap_good_data_net_weight_quantity;
                tmp.ap_good_data_invoiced_cost =
                  good.ap_good_data_invoiced_cost;
                tmp.ap_good_data_customs_cost = good.ap_good_data_customs_cost;
                tmp.ap_good_data_statistical_cost =
                  good.ap_good_data_statistical_cost;

                this.ap_good_data.push(tmp);
              });
            }
            //this.hideAddProduct();
          });
      }
    },
  },
  mounted() {
    this.fetchCurrencies();
    this.fetchContragents("");
    this.fetchCustdocKinds("");
    this.fetchTNVED("");
    this.fetchMeasures("");
    this.fetchCountries("");
    this.fetchDeliveryTerms("");
    this.fetchCustomsOffices("");
    this.fetchTransportModeCodes("");
    this.fetchTransKinds("");
    this.fetchDeclarationKinds("");
    this.fetchMovementCodes("");
    this.$root.$on("go_to_epi_error", (error_data) => {
      this.go_to_error(error_data);
    });

    if (this.document_id == "new") {
      var date = new Date();

      this.ap_main.ap_main_reg_num =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
        "-" +
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1);
      this.ap_main.ap_main_reg_date = moment().format("YYYY-MM-DD");
      this.ap_main.ap_main_electronic_document_sign = true;
      this.ap_main.ap_main_language_cuesad = "ru";
      setTimeout(() => {
        this.ap_main.ap_main_recipient_country_code =
          this.countries[this.countries.findIndex((cnt) => cnt.value == "KZ")];
        this.ap_goods.ap_good_cust_cost_currency_code =
          this.currencies[
            this.currencies.findIndex((cur) => cur.value == "398")
          ];
        this.ap_transportations.ap_transp_container_indicator = 0;
        this.ap_transportations.ap_transp_transport_mode_code =
          this.transport_mode_codes[
            this.transport_mode_codes.findIndex((i) => i.value == 30)
          ];
      }, 1500);

      //load invoice
      axios
        .get(
          window.base + "/document?attis_contract_id=" + this.$route.params.id,
        )
        .then((response) => {
          response.data.forEach((item) => {
            // if (item.DocType !== "ЭПИ") {
            //   let tmp_doc = {
            //     ap_prev_doc_preceding_document_date: item.DocumentDate,
            //     ap_prev_doc_preceding_document_number: item.DocumentNumber,
            //     ap_prev_doc_preceding_document_name: item.DocType,
            //   };
            //   this.ap_prev_docs.push(tmp_doc);
            // }
            if (item.DocType == "Инвойс") {
              axios
                .get(
                  window.base +
                    "/Document/LoadInvoice/?doc_id=" +
                    item.DocumentID,
                )
                .then((response) => {
                  let country_code = "";
                  response.data.product.forEach((good, index) => {
                    let tmp = {
                      ap_good_data_goods_numeric: index + 1,
                      ap_good_data_list_numeric: index + 1,
                      good_guid: good.good_guid,
                      good_no: good.good_no,
                      ap_good_data_goods_description: good.GoodsDescription,
                      ap_good_data_gross_weight_quantity:
                        good.GrossWeightQuantity,
                      ap_good_data_net_weight_quantity: good.NetWeightQuantity,
                      ap_good_data_invoiced_cost: good.Price,
                      ap_good_data_customs_cost: 0,
                      ap_good_data_statistical_cost: 0,
                      ap_good_data_quant: 0,
                      ap_good_data_container_num: "",
                      ap_good_data_places: "",
                      ap_good_data_places_name: "",
                      ap_good_data_packet:
                        this.ap_good_data_packets[
                          this.ap_good_data_packets.findIndex(
                            (i) => i.value == 0,
                          )
                        ],
                      ap_good_data_goods_tnved_code: { value: "" },
                      ap_good_data_origin_country_code: { value: "" },
                      ap_good_data_delivery_terms_string_code:
                        this.contract_details.attis_contract_delivery_term,
                      ap_good_data_ext_measure: { value: "", display_text: "" },
                    };

                    this.ap_good_data.push(tmp);
                    if (good.OriginCountryCode.trim() !== "")
                      country_code = good.OriginCountryCode.trim();
                    this.findLibValueProduct(
                      "tnved",
                      good.GoodsCode.trim(),
                      "ap_good_data_goods_tnved_code",
                      index,
                    );
                    this.findLibValueProduct(
                      "country",
                      good.OriginCountryCode.trim(),
                      "ap_good_data_origin_country_code",
                      index,
                    );
                  });
                  this.ap_goods.ap_good_total_goods_number =
                    response.data.product.length;
                  this.ap_goods.ap_good_origin_country_name =
                    this.countries[
                      this.countries.findIndex((i) => i.value == country_code)
                    ];

                  this.ap_goods.ap_good_total_package_number =
                    response.data.PlacesQuantity;
                  this.ap_goods.ap_good_total_cust_cost = response.data.GCost;
                });
            }
            if (item.DocType == "CMR") {
              axios
                .get(
                  window.base + "/Document/LoadCMR/?doc_id=" + item.DocumentID,
                )
                .then((response) => {
                  this.ap_transportations.ap_transp_transport_identifier =
                    response.data.cmr_track;
                  this.ap_transportations.ap_transp_active_transport_identifier =
                    response.data.cmr_track;

                  this.ap_transportations.ap_transp_destination_country_code =
                    this.countries[
                      this.countries.findIndex(
                        (itm) => itm.value == response.data.CountryCode.trim(),
                      )
                    ];
                  this.ap_transportations.ap_transp_dispatch_country_code =
                    this.countries[
                      this.countries.findIndex(
                        (itm) => itm.value == response.data.CountryCode.trim(),
                      )
                    ];

                  axios
                    .get(
                      window.base +
                        "/document/getFirmbyBin?bin=" +
                        response.data.cmr_courier,
                    )
                    .then((response) => {
                      this.ap_members5.ap_memb_organization_name =
                        response.data.organizations.org_name;
                      this.ap_members5.ap_memb_short_name =
                        response.data.organizations.org_name;
                      this.ap_members5.ap_memb_bin =
                        response.data.organizations.org_code;
                      this.ap_members5.ap_member_postal_code =
                        response.data.addresses[0].post_addr_index;
                      this.ap_members5.ap_member_country_name =
                        this.countries[
                          this.countries.findIndex(
                            (cnt) =>
                              cnt.value ==
                              response.data.addresses[0].post_addr_country,
                          )
                        ];
                      this.ap_members5.ap_member_region =
                        response.data.addresses[0].post_addr_region;
                      this.ap_members5.ap_member_city =
                        response.data.addresses[0].post_addr_city;
                      this.ap_members5.ap_member_street_house =
                        response.data.addresses[0].post_addr_streethouse +
                        " " +
                        response.data.addresses[0].post_addr_room;
                    });
                });
            }
            // if(item.DocType=='ФМ1'){
            // 	axios.get(window.base + '/Document/LoadFM1/?doc_id='+item.DocumentID).then(response=>{

            // 		axios.get(window.base + '/document/getFirmDetails?bin='+response.data.fm1_subj_iin_bin).then(response=>{
            // 			this.ap_members3.ap_memb_organization_name = response.data.org_name
            // 			this.ap_members3.ap_memb_short_name = response.data.org_name
            // 			this.ap_members3.ap_memb_bin = response.data.org_code
            // 			this.ap_members3.ap_member_street_house = response.data.company_address
            // 			this.ap_members3.ap_member_postal_code = response.data.org_post_infex
            // 			this.ap_members3.ap_member_country_name = response.data.org_residency
            // 			this.ap_members3.ap_member_region = response.data.company_region
            // 			this.ap_members3.ap_member_street_house = response.data.company_address
            // 		})
            // 	})
            // }
          });
        });

      if (this.contract_details.attis_contract_type) {
        //I'm buyer
        axios
          .get(
            window.base +
              "/document/getFirmDetails?bin=" +
              this.contract_details.attis_contract_contragent.value,
          )
          .then((response) => {
            this.ap_members1.ap_memb_organization_name = response.data.org_name;
            this.ap_members1.ap_memb_short_name = response.data.org_name;
            this.ap_members1.ap_memb_bin = response.data.org_code;
            this.ap_members1.ap_member_street_house =
              response.data.company_address;
            this.ap_members1.ap_member_postal_code =
              response.data.org_post_infex;

            this.ap_members1.ap_member_country_name =
              response.data.org_residency;
            this.ap_members1.ap_member_region = response.data.company_region;
            this.ap_members1.ap_member_street_house =
              response.data.company_address;
          });
        axios.get(window.base + "/document/getfirmfull").then((response) => {
          this.$store.commit("load_firm", response.data);
          this.ap_members2.ap_memb_organization_name =
            response.data.organizations.org_name;
          this.ap_members2.ap_memb_short_name =
            response.data.organizations.org_name;
          this.ap_members2.ap_memb_bin = response.data.organizations.org_code;
          this.ap_members2.ap_member_postal_code =
            response.data.addresses[0].post_addr_index;
          this.ap_members2.ap_member_country_name =
            this.countries[
              this.countries.findIndex(
                (cnt) =>
                  cnt.value == response.data.addresses[0].post_addr_country,
              )
            ];
          this.ap_members2.ap_member_region =
            response.data.addresses[0].post_addr_region;
          this.ap_members2.ap_member_city =
            response.data.addresses[0].post_addr_city;
          this.ap_members2.ap_member_street_house =
            response.data.addresses[0].post_addr_streethouse +
            " " +
            response.data.addresses[0].post_addr_room;

          this.ap_members4.ap_memb_organization_name =
            response.data.organizations.org_name;
          this.ap_members4.ap_memb_short_name =
            response.data.organizations.org_name;
          this.ap_members4.ap_memb_bin = response.data.organizations.org_code;
          this.ap_members4.ap_member_street_house =
            response.data.organizations.company_address;
          this.ap_members4.ap_member_postal_code =
            response.data.organizations.org_post_infex;
          this.ap_members4.ap_member_postal_code =
            response.data.organizations.org_post_index;
          this.ap_members4.ap_member_country_name = response.data.org_residency;
          this.ap_members4.ap_member_region =
            response.data.organizations.company_region;
          this.ap_members4.ap_member_street_house =
            response.data.company_address;

          this.ap_members3.ap_memb_organization_name =
            response.data.organizations.org_name;
          this.ap_members3.ap_memb_short_name =
            response.data.organizations.org_name;
          this.ap_members3.ap_memb_bin = response.data.organizations.org_code;
          this.ap_members3.ap_memb_itn =
            response.data.organizations.org_custom_code;
        });
        axios
          .get(
            window.base +
              "/contract/selectedBrokerOffer?contract_id=" +
              this.$route.params.id,
          )
          .then((response) => {
            this.ap_persons.ap_person_person_surname = response.data.last_name;
            this.ap_persons.ap_person_person_name = response.data.given_name;
            this.ap_persons.ap_person_person_middle_name =
              response.data.middle_name;
            this.ap_persons.ap_person_person_post = response.data.position;

            this.ap_members4.ap_memb_organization_name = response.data.org_name;
            this.ap_members4.ap_memb_short_name = response.data.org_name;
            this.ap_members4.ap_memb_bin = response.data.org_code;
            this.ap_members4.ap_memb_itn = response.data.custom_code;
          });
        axios
          .get(
            window.base +
              "/contract/selectedBrokerOffer?contract_id=" +
              this.$route.params.id,
          )
          .then((response) => {
            this.ap_persons.ap_person_person_surname = response.data.last_name;
            this.ap_persons.ap_person_person_name = response.data.given_name;
            this.ap_persons.ap_person_person_middle_name =
              response.data.middle_name;
            this.ap_persons.ap_person_person_post = response.data.position;
          });
      } else {
        //I'm seller
        axios.get(window.base + "/document/getfirmfull").then((response) => {
          this.$store.commit("load_firm", response.data);
          this.ap_members1.ap_memb_organization_name =
            response.data.organizations.org_name;
          this.ap_members1.ap_memb_short_name =
            response.data.organizations.org_name;
          this.ap_members1.ap_memb_bin = response.data.organizations.org_code;
          this.ap_members1.ap_member_street_house =
            response.data.organizations.company_address;
          this.ap_members1.ap_member_postal_code =
            response.data.organizations.org_post_infex;

          this.ap_members1.ap_member_postal_code =
            response.data.organizations.org_post_index;
          this.ap_members1.ap_member_country_name = response.data.org_residency;
          this.ap_members1.ap_member_region =
            response.data.organizations.company_region;
          this.ap_members1.ap_member_street_house =
            response.data.company_address;

          this.ap_members4.ap_memb_organization_name =
            response.data.organizations.org_name;
          this.ap_members4.ap_memb_short_name =
            response.data.organizations.org_name;
          this.ap_members4.ap_memb_bin = response.data.organizations.org_code;
          this.ap_members4.ap_member_street_house =
            response.data.organizations.company_address;
          this.ap_members4.ap_member_postal_code =
            response.data.organizations.org_post_infex;
          this.ap_members4.ap_member_postal_code =
            response.data.organizations.org_post_index;
          this.ap_members4.ap_member_country_name = response.data.org_residency;
          this.ap_members4.ap_member_region =
            response.data.organizations.company_region;
          this.ap_members4.ap_member_street_house =
            response.data.company_address;

          this.ap_members3.ap_memb_organization_name =
            response.data.organizations.org_name;
          this.ap_members3.ap_memb_short_name =
            response.data.organizations.org_name;
          this.ap_members3.ap_memb_bin = response.data.organizations.org_code;
          this.ap_members3.ap_memb_itn =
            response.data.organizations.org_custom_code;
        });
        axios
          .get(
            window.base +
              "/document/getFirmbyBin?bin=" +
              this.contract_details.attis_contract_contragent.value,
          )
          .then((response) => {
            this.ap_members2.ap_memb_organization_name =
              response.data.organizations.org_name;
            this.ap_members2.ap_memb_short_name =
              response.data.organizations.org_name;
            this.ap_members2.ap_memb_bin = response.data.organizations.org_code;
            this.ap_members2.ap_member_postal_code =
              response.data.addresses[0].post_addr_index;
            this.ap_members2.ap_member_country_name =
              this.countries[
                this.countries.findIndex(
                  (cnt) =>
                    cnt.value == response.data.addresses[0].post_addr_country,
                )
              ];
            this.ap_members2.ap_member_region =
              response.data.addresses[0].post_addr_region;
            this.ap_members2.ap_member_city =
              response.data.addresses[0].post_addr_city;
            this.ap_members2.ap_member_street_house =
              response.data.addresses[0].post_addr_streethouse +
              " " +
              response.data.addresses[0].post_addr_room;
          });
        axios
          .get(
            window.base +
              "/contract/selectedBrokerOffer?contract_id=" +
              this.$route.params.id,
          )
          .then((response) => {
            this.ap_persons.ap_person_person_surname = response.data.last_name;
            this.ap_persons.ap_person_person_name = response.data.given_name;
            this.ap_persons.ap_person_person_middle_name =
              response.data.middle_name;
            this.ap_persons.ap_person_person_post = response.data.position;
            this.ap_persons.ap_person_contact_phone =
              response.data.phone_number;

            this.ap_members4.ap_memb_organization_name = response.data.org_name;
            this.ap_members4.ap_memb_short_name = response.data.org_name;
            this.ap_members4.ap_memb_bin = response.data.org_code;
            this.ap_members4.ap_memb_itn = response.data.custom_code;
          });
        //финансовое урегулирование
      }

      this.ap_goods.ap_good_origin_country_name =
        this.countries[
          this.countries.findIndex((cnt) => cnt.value == country_code)
        ];

      // this.Invoice.CurrencyCode = this.contract_details.attis_contract_currency
      // if(typeof this.goods !== 'undefined')
      // 	this.goods.forEach(good=>{
      // 		var tmp_good = {}
      // 		tmp_good.GoodsNomenclatureCode = good.attis_cg_TNVED
      // 		tmp_good.GoodsDescription = good.attis_cg_good_name
      // 		tmp_good.GoodsQuantity = good.attis_cg_quantity
      // 		// tmp_good.SupplementaryQualifierName = good.attis_cg_measures
      // 		// tmp_good.Price = good.attis_cg_price

      // 		this.CMRGoods.push(tmp_good)
      // 	})
    } else {
      this.load();
    }

    // this.$root.$on('saveDocument', (data)=>{
    // 	if(typeof data.document.attis_contract_doc_type === 'object'){
    // 		if(data.document.attis_contract_doc_type.value=='epi'){
    // 			this.saveDocument(data)
    // 		}
    // 	}else{
    // 		if(data.document.attis_contract_doc_type=='epi'){
    // 			this.saveDocument(data)
    // 		}
    // 	}
    // })
    this.$root.$on("set.buyer.contragent", (data) => {
      this.Invoice.InvoiceByer = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
    this.$root.$on("set.seller.contragent", (data) => {
      this.Invoice.InvoiceSeller = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
        case "ru":
          locale = "ru-RU";
          break;
      }
      return locale;
    },
    is_field_readonly() {
      if (this.ap_main.IsSigned) return true;
      return false;
    },
    is_utin() {
      if (this.buttons_loading || this.ap_main.ap_astana_utin) return true;
      return false;
    },
  },
  validations() {
    var v = {
      ap_main: {
        ap_main_decl_num: {
          required,
        },
        ap_main_reg_num: {
          required,
        },
        ap_main_decl_date: {
          required,
        },
        // ap_main_country_code: {
        // 	required
        // },
        // ap_main_trans_kind_code: {
        // 	required
        // },
        // ap_main_recipient_country_code: {
        // 	required
        // },
        ap_main_seal_quantity: {
          required,
        },
      },
      ap_goods: {
        ap_good_total_goods_number: {
          required,
        },
      },
      ap_persons: {
        ap_person_person_surname: {
          required,
        },
        ap_person_person_name: {
          required,
        },
      },
      // ap_good_data_single: {
      // 	ap_good_data_goods_numeric: {
      // 		required,
      // 	},
      // 	ap_good_data_list_numeric: {
      // 		required
      // 	}
      // }
    };
    return v;
  },
};
</script>
<style scoped>
#products-table.error {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>
